<template>
  <div
    class="cesium-container"
    :class="{ 'data-ui': isDataUi && !dataCenter, 'filght-sumulation': FlightSimulationFlag }"
  >
    <MediaView
      @close="closeCurrentMedia"
      :currentIndex="currentIndex"
      :mediaList="currentMediaList"
      @toggle-map="setCurrent"
      @prev="setCurrent"
      @next="setCurrent"
      @switch="mediaSwitch"
    />
    <div
      class="notie-list"
      v-show="!isDataUi && !FlightSimulationFlag"
      v-if="notieList.length > 0"
      :class="{
        active: getActive,
        'is-waline-edit': isWaylineEdit,
        'is-device': is_waylineDevice,
        'is-template': is_waylineTemplate,
      }"
    >
      <div class="notie-title-type">{{ notieList[0].categoryName }}</div>
      <div class="notie-title-value">
        {{ notieList.map((dict) => dict.title).join() }}
      </div>
      <router-link
        :to="{ path: 'notie-detail' }"
        target="_blank"
        class="detail-btn"
      >
        <div>详情</div>
        <div class="arrow-right" />
      </router-link>
    </div>
    <!-- 建筑模型控制面板 -->
    <div v-if="showBuildingControls" class="building-control-panel">
      <div class="panel-header">
        <h4>3D建筑模型</h4>
        <CloseOutlined @click="showBuildingControls = false" />
      </div>

      <div class="panel-content">
        <!-- 错误提示 -->
        <div v-if="buildingError" class="error-message">
          <a-alert :message="buildingError" type="error" show-icon />
        </div>
        <a-select
          v-model:value="selectedBuildingLayer"
          placeholder="选择建筑数据源"
          style="width: 100%; margin-bottom: 10px"
          @change="handleBuildingLayerChange"
        >
          <a-select-option value="osm">OSM建筑数据（免费）</a-select-option>
          <a-select-option value="test">测试建筑模型</a-select-option>
          <a-select-option value="custom">自定义3D Tiles</a-select-option>
          <!-- 可以添加更多选项 -->
        </a-select>

        <div v-if="selectedBuildingLayer === 'custom'" class="custom-input">
          <a-alert
            message="请输入有效的3D Tiles URL"
            type="info"
            show-icon
            style="margin-bottom: 10px"
          />
          <a-input
            v-model:value="customTilesetUrl"
            placeholder="例如: https://example.com/tileset.json"
            style="margin-bottom: 10px"
          />
          <a-button type="primary" @click="loadCustomBuildings" block
            >加载</a-button
          >
        </div>

        <div v-if="selectedBuildingLayer === 'osm'" class="data-source-info">
          <a-alert
            message="使用ArcGIS免费3D建筑数据，加载可能需要一些时间"
            type="warning"
            show-icon
            style="margin-bottom: 10px"
          />
        </div>

        <div class="building-controls">
          <a-button
            type="primary"
            :disabled="!currentBuildingTileset"
            @click="toggleBuildings"
          >
            {{ buildingsVisible ? "隐藏" : "显示" }}建筑
          </a-button>

          <a-button
            :disabled="!currentBuildingTileset"
            @click="removeBuildings"
            style="margin-left: 10px"
          >
            移除
          </a-button>
        </div>

        <!-- 性能统计 -->
        <div v-if="currentBuildingTileset" class="performance-stats">
          <div class="stat-item">
            <span>加载级别:</span>
            <a-progress
              :percent="loadProgress"
              size="small"
              style="width: 60px; margin-left: 10px"
            />
          </div>
          <div v-if="memoryUsage > 0" class="stat-item">
            <span>内存使用:</span>
            <span>{{ memoryUsage }} MB</span>
          </div>
        </div>

        <!-- 使用说明 -->
        <div class="usage-tips">
          <a-alert
            message="使用提示"
            description="1. 免费数据源可能较慢 2. 大型模型需要良好网络 3. 建议先加载测试模型"
            type="info"
            show-icon
          />
        </div>
      </div>
    </div>
    <div class="map-sidebar-com">
      <FlySetting v-hasPermi="['wayline:fly']" />
      <MarkInfo v-hasPermi="['wayline:draw']" />
      <div
        class="route-core-info"
        v-hasPermi="['wayline:current']"
        :class="{
          'is-template': is_waylineTemplate,
          'is-device': is_waylineDevice,
        }"
        style=""
        v-if="waylineInfo && Object.keys(waylineInfo).length > 0"
      >
        <div class="top">
          <div class="route-name">{{ waylineInfo.name }}</div>
          <div class="create-info">
            <user-outlined />
            <div class="creator">{{ waylineInfo.user_name }}</div>
            <div class="phone"></div>
            <clock-circle-outlined />
            <div class="create-time">
              {{ dayjs(waylineInfo.create_time).format("YYYY-MM-DD") }}
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="wayline-info-item">
            <div class="title">航线长度</div>
            <div class="text">{{ waylineInfo.wayline_length }} 米</div>
          </div>
          <div class="wayline-info-item" style="">
            <div class="title">航点数量</div>
            <div class="text">{{ waylineInfo.wayline_count }} 个</div>
          </div>
          <div class="wayline-info-item">
            <div class="title">预估时间</div>
            <div class="text">{{ secondsToTextBetter(Number(waylineInfo.estimated_time)) || "--" }}</div>
          </div>
          <div class="wayline-info-item">
            <div class="title">关联机场</div>
            <div class="text">--</div>
          </div>
          <div class="wayline-info-item">
            <div class="title">航线属性</div>
            <span class="text">通用航线</span>
          </div>
          <div class="wayline-info-item end-update-time">
            <div class="title">最后修改时间</div>
            <span class="update-time">{{
              dayjs(waylineInfo.update_time).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </div>
        </div>
      </div>
      <!-- 操作按钮面板 -->
      <div
        v-hasPermi="['wayline:draw']"
        class="cesium-action-pane"
        :class="{ edit: showEditRouter }"
        v-show="
          !isSettingPlanar &&
          !isDataUi &&
          !FlightSimulationFlag &&
          !isSettingStrip
        "
      >
        <!-- 绘制模式 -->
        <g-action-type
          class="g-action-item mt10"
          :class="{
            selection: states.isDraw && states.currentType !== 'PointLine',
          }"
          @select-action="drawCesium"
          @click="drawCesium"
        ></g-action-type>
        <div
          v-if="states.isDraw && states.currentType !== 'PointLine'"
          class="g-action-item"
          @click="drawCesium(states.currentType)"
        >
          <a style="color: red">
            <CloseOutlined />
          </a>
        </div>
        <a-popover
          overlayClassName="css-1dowtov"
          placement="leftTop"
          trigger="hover"
          @visibleChange="handleVisible"
        >
        <div class="g-action-item">
          <aim-outlined />
        </div>
        <template #title>
          <span class="title-loction">定位</span>
        </template>
          <template #content>
            <div class="location-panel">
        <div class="location-field">
          <div class="field-label">经度</div>
          <a-input-number
            size="small"
            placeholder="如：116.397428"
            v-model:value="lon_text"
            :step="0.000001"
          />
        </div>
        <div class="location-field">
          <div class="field-label">纬度</div>  <!-- 修正：原为“经度” -->
          <a-input-number
            size="small"
            placeholder="如：39.909187"
            v-model:value="lat_text"
            :step="0.000001"
          />
        </div>
        <a-button type="primary" size="small" @click="locate" block>定位</a-button>
      </div>
          </template>
        </a-popover>
        <!-- 测距按钮 -->
        <div
          class="g-action-item"
          :class="{ selection: measureActive }"
          @click="toggleMeasureDistance"
        >
          <partition-outlined />
        </div>

        <div
          class="g-action-item model-list-btn"
          @mouseenter="showModelChange"
          @mouseleave="handleMouseLeave"
          v-if="modelTreeData.length > 0"
        >
          <unordered-list-outlined />
          <!-- 树形结构模型列表悬停面板 -->
          <div
            v-if="showModelList && modelTreeData.length > 0"
            class="tree-model-list-popover"
            @mouseenter="keepModelList = true"
            @mouseleave="hideModelList"
          >
            <div class="tree-list-header">
              <span class="tree-list-title">模型树列表</span>
              <!-- <span class="model-count">{{ getTotalModelCount() }}个模型</span> -->
            </div>
            <div class="tree-list-content">
              <a-tree
                :tree-data="modelTreeData"
                :expanded-keys="expandedKeys"
                :selected-keys="selectedModelKeys"
                :checked-keys="modelCheckedKeys"
                checkable
                @expand="(keys) => expandedKeys = keys"
                @select="onModelSelect"
                @check="onModelCheck"
                class="model-a-tree"
              />
            </div>

            <!-- <div class="tree-list-content">
              <div
                v-for="workspace in modelTreeData"
                :key="workspace.key"
                class="tree-workspace"
              >
                <div
                  class="tree-workspace-header"
                  @click="toggleTreeNode(workspace.key)"
                >
                  <div class="tree-node-title">
                    <caret-right-outlined
                      v-if="!expandedTreeNodes[workspace.key]"
                      class="tree-caret-icon"
                    />
                    <caret-down-outlined v-else class="tree-caret-icon" />
                    <span class="tree-node-name">{{ workspace.title }}</span>
                    <span class="tree-node-count">{{
                      countWorkspaceModels(workspace)
                    }}</span>
                  </div>
                </div>
                <div
                  v-if="expandedTreeNodes[workspace.key]"
                  class="tree-children"
                >
                  <div
                    v-for="folder in workspace.children"
                    :key="folder.key"
                    class="tree-folder"
                  >
                    <div
                      class="tree-folder-header"
                      @click="toggleTreeNode(folder.key)"
                    >
                      <div class="tree-node-title">
                        <caret-right-outlined
                          v-if="!expandedTreeNodes[folder.key]"
                          class="tree-caret-icon"
                        />
                        <caret-down-outlined v-else class="tree-caret-icon" />
                        <span class="tree-node-name">{{ folder.title }}</span>
                        <span class="tree-node-count">{{
                          countFolderModels(folder)
                        }}</span>
                      </div>
                    </div>
                    <div
                      v-if="
                        expandedTreeNodes[folder.key] &&
                        folder.children &&
                        folder.children.length > 0
                      "
                      class="tree-subfolders"
                    >
                      <div
                        v-for="subFolder in folder.children"
                        :key="subFolder.key"
                        class="tree-subfolder"
                      >
                        <div
                          class="tree-subfolder-header"
                          @click="toggleTreeNode(subFolder.key)"
                        >
                          <div class="tree-node-title">
                            <caret-right-outlined
                              v-if="!expandedTreeNodes[subFolder.key]"
                              class="tree-caret-icon"
                            />
                            <caret-down-outlined
                              v-else
                              class="tree-caret-icon"
                            />
                            <span class="tree-node-name">{{
                              subFolder.title
                            }}</span>
                            <span class="tree-node-count">{{
                              countSubFolderModels(subFolder)
                            }}</span>
                          </div>
                        </div>
                        <div
                          v-if="
                            expandedTreeNodes[subFolder.key] &&
                            subFolder.children &&
                            subFolder.children.length > 0
                          "
                          class="tree-models"
                        >
                          <div
                            v-for="model in subFolder.children"
                            :key="model.key"
                            class="tree-model"
                          >
                            <div
                              class="tree-model-header"
                              @click="toggleTreeNode(model.key)"
                            >
                              <div class="tree-node-title">
                                <caret-right-outlined
                                  v-if="!expandedTreeNodes[model.key]"
                                  class="tree-caret-icon"
                                />
                                <caret-down-outlined
                                  v-else
                                  class="tree-caret-icon"
                                />
                                <span class="tree-node-name">{{
                                  model.title
                                }}</span>
                                <span class="tree-node-count">{{
                                  countModelTypes(model)
                                }}</span>
                              </div>
                            </div>
                            <div
                              v-if="
                                expandedTreeNodes[model.key] &&
                                model.children &&
                                model.children.length > 0
                              "
                              class="tree-model-types"
                            >
                              <div
                                v-for="modelType in model.children"
                                :key="modelType.key"
                                class="tree-model-type"
                                :class="{
                                  active: isModelTypeActive(modelType.key),
                                }"
                                @click="selectModelType(modelType)"
                              >
                                <div class="model-type-content">
                                  <div class="model-type-icon">
                                    <file-text-outlined
                                      v-if="modelType.dataRef.type === 'model'"
                                    />
                                    <file-outlined v-else />
                                  </div>
                                  <div class="model-type-info">
                                    <span class="model-type-name">{{
                                      modelType.title
                                    }}</span>
                                    <span class="model-type-desc">{{
                                      getModelTypeDesc(modelType.dataRef.type)
                                    }}</span>
                                  </div>
                                  <check-outlined
                                    v-if="isModelTypeActive(modelType.key)"
                                    class="model-type-check"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <!-- <div class="g-action-item" @click="showBuildingControls = !showBuildingControls">
          <HomeFilled />
        </div> -->
        <a-popover
          v-hasPermi="['wayline:draw']"
          overlayClassName="css-vslrb1"
          placement="left"
          trigger="hover"
          v-if="showEditRouter"
        >
          <div
            class="g-action-item"
            :class="{
              selection: states.currentType === 'PointLine',
              disabled: isEdit,
            }"
            @click="drawCesium('PointLine')"
          >
            <a>
              <ForkOutlined />
            </a>
          </div>
          <template #title>{{ "" }}</template>
          <template #content>
            <div class="add-waypoint-tips">
              <div class="a-d-t a-d-t-title">
                <svg-icon
                  size="18"
                  color="#fff"
                  name="route-mouse-left"
                ></svg-icon>
                <div class="a-d-t-title-text">点击地图快速新增航点</div>
              </div>
              <div class="a-d-t a-d-t-content">
                <div class="a-d-t-c-key">CTRL</div>
                <div class="a-d-t-c-add">+</div>
                <svg-icon
                  size="18"
                  color="#fff"
                  name="route-mouse-left"
                ></svg-icon>
                <div class="a-d-t-c-text">在选中航点前插入航点</div>
              </div>
              <div class="a-d-t a-d-t-content">
                <div class="a-d-t-c-key">ALT</div>
                <div class="a-d-t-c-add">+</div>
                <svg-icon
                  size="18"
                  color="#fff"
                  name="route-mouse-left"
                ></svg-icon>
                <div class="a-d-t-c-text">在选中航点后插入航点</div>
              </div>
            </div>
          </template>
        </a-popover>

        <FlightAreaActionIcon
          v-if="isFlightAreaRouter"
          class="g-action-item mt10"
          :class="{ selection: mouseMode && isFlightArea }"
          @select-action="selectFlightAreaAction"
          @click="selectFlightAreaAction"
        />
        <div v-if="mouseMode" class="g-action-item" @click="draw('off', false)">
          <a style="color: red">
            <CloseOutlined />
          </a>
        </div>
      </div>
      <flyContrainer
        v-if="FlightSimulationFlag"
        v-hasPermi="['wayline:fly']"
      ></flyContrainer>
      <!-- 飞行区绘制弹层 -->
      <FlightAreaDrawModal
        v-model="showDrawModal"
        :area-data="currentAreaData"
        @confirm="handleAreaConfirm"
        @cancel="handleAreaCancel"
      />
      <AirportModal />
      <div
        class="share-point-panel"
        v-if="sharePane.show"
        v-hasPermi="['wayline:share']"
      >
        <div class="share-btn">扫码分享</div>
        <div class="share-image-box">
          <qrcode-vue :value="sharePane.img" :size="104" level="H" />
        </div>
      </div>

      <div class="m-s-right-btn" :class="{ 'data-ui': isDataUi && !dataCenter }">
        <a-popover
          v-hasPermi="['wayline:cloud']"
          overlayClassName="css-vslrb1"
          placement="left"
          trigger="hover"
        >
          <template #title>{{ "" }}</template>
          <template #content>
            <a-switch
              v-model:checked="showPointCloud"
              checked-children="点云-开启"
              un-checked-children="点云-关闭"
            ></a-switch>
            <br />
            <a-switch
              v-model:checked="showModelTileset"
              checked-children="模型-开启"
              un-checked-children="模型-关闭"
            ></a-switch>
          </template>
          <div class="m-s-icon td">
            <radar-chart-outlined />
          </div>
        </a-popover>
        <div class="m-s-icon td" @click="handleChangeModel">
          {{ MapTypeName[states.mapType] }}
        </div>

        <a-popover
          v-hasPermi="['wayline:tool:fly']"
          overlayClassName="css-vslrb1"
          placement="left"
          trigger="hover"
        >
          <template #title>{{ "" }}</template>
          <template #content>
            <div class="flight-area">
              <div class="f-a-switch">
                <a-switch
                  class="css-vslrb1"
                  v-model:checked="isFlyArea"
                  @change="handleSwitchChange"
                ></a-switch>
                <div class="txt">显示自定义飞行区</div>
              </div>
              <a-divider class="css-vslrb1" style="margin: 8px 0px" />
              <div class="f-a-txt">
                <div class="round color1"></div>
                <div class="txt">自定义限飞区</div>
              </div>
              <div class="f-a-txt">
                <div class="round color2"></div>
                <div class="txt">自定义作业区</div>
              </div>
              <div class="f-a-switch">
                <a-switch
                  class="css-vslrb1"
                  v-model:checked="isCustumFlyArea"
                  @change="handleSwitchCustumChange"
                ></a-switch>
                <div class="txt">显示限飞区</div>
              </div>
              <a-divider class="css-vslrb1" style="margin: 8px 0px" />
              <div class="f-a-check">
                <a-checkbox
                  v-model:checked="isCustumFlyArea"
                  @change="handleSwitchCustumChange(!isCustumFlyArea)"
                >
                  <div class="check-content">
                    <div class="round color3"></div>
                    <div class="check-txt">禁飞区</div>
                  </div>
                </a-checkbox>
              </div>
              <div class="f-a-check">
                <a-checkbox
                  v-model:checked="isCustumFlyArea"
                  @change="handleSwitchCustumChange(!isCustumFlyArea)"
                >
                  <div class="check-content">
                    <div class="round color4"></div>
                    <div class="check-txt">限高区</div>
                  </div>
                </a-checkbox>
              </div>
              <div class="f-a-check">
                <a-checkbox
                  v-model:checked="isCustumFlyArea"
                  @change="handleSwitchCustumChange(!isCustumFlyArea)"
                >
                  <div class="check-content">
                    <div class="round color5"></div>
                    <div class="check-txt">授权区</div>
                  </div>
                </a-checkbox>
              </div>
              <div class="f-a-check">
                <a-checkbox
                  v-model:checked="isCustumFlyArea"
                  @change="handleSwitchCustumChange(!isCustumFlyArea)"
                >
                  <div class="check-content">
                    <div class="round color6"></div>
                    <div class="check-txt">警示区</div>
                  </div>
                </a-checkbox>
              </div>
              <div class="f-a-check">
                <a-checkbox
                  v-model:checked="isCustumFlyArea"
                  @change="handleSwitchCustumChange(!isCustumFlyArea)"
                >
                  <div class="check-content">
                    <div class="round color7"></div>
                    <div class="check-txt">加强警示区</div>
                  </div>
                </a-checkbox>
              </div>
              <div class="f-a-check">
                <a-checkbox
                  v-model:checked="isCustumFlyArea"
                  @change="handleSwitchCustumChange(!isCustumFlyArea)"
                >
                  <div class="check-content">
                    <div class="round color8"></div>
                    <div class="check-txt">法规限制区</div>
                  </div>
                </a-checkbox>
              </div>
              <div class="f-a-check">
                <a-checkbox
                  v-model:checked="isCustumFlyArea"
                  @change="handleSwitchCustumChange(!isCustumFlyArea)"
                >
                  <div class="check-content">
                    <div class="round color9"></div>
                    <div class="check-txt">轻型无人机适飞区</div>
                  </div>
                </a-checkbox>
              </div>
              <a-divider class="css-vslrb1" style="margin: 8px 0px" />
              <div class="f-a-tips">查看临时限飞区</div>
            </div>
          </template>
          <div class="m-s-icon td">
            <info-circle-outlined />
          </div>
        </a-popover>

        <a-popover
          overlayClassName="css-vslrb1"
          placement="left"
          trigger="hover"
        >
          <template #title>{{ "" }}</template>
          <template #content>
            <div class="uva-level">
              <div class="v-l-tip">
                <div class="tip-txt">载人飞机碰撞风险</div>
                <div class="tip-txt">
                  <i
                    class="iconfont icon-shezhi"
                    @click="handleShowFlySetting"
                  ></i>
                </div>
              </div>
              <div class="v-l-check">
                <a-checkbox
                  v-model:checked="flyErrorStatus"
                  @change="
                    handleChangeCheckChange('flyErrorStatus', !flyErrorStatus)
                  "
                >
                  <div class="check-content">
                    <svg-icon
                      name="fly"
                      :size="18"
                      color="#dc4446"
                      className="color-error"
                    ></svg-icon>
                    <div class="check-txt">高风险</div>
                  </div>
                </a-checkbox>
              </div>
              <div class="v-l-check">
                <a-checkbox
                  v-model:checked="flyWarningStatus"
                  @change="
                    handleChangeCheckChange(
                      'flyWarningStatus',
                      !flyWarningStatus,
                    )
                  "
                >
                  <div class="check-content">
                    <svg-icon
                      name="fly"
                      :size="18"
                      color="#d89614"
                      className="color-warning"
                    ></svg-icon>
                    <div class="check-txt">中风险</div>
                  </div>
                </a-checkbox>
              </div>
              <div class="v-l-check">
                <a-checkbox
                  v-model:checked="flyPrimaryStatus"
                  @change="
                    handleChangeCheckChange(
                      'flyPrimaryStatus',
                      !flyPrimaryStatus,
                    )
                  "
                >
                  <div class="check-content">
                    <svg-icon
                      name="fly"
                      :size="18"
                      color="#297acf"
                      className="color-primary"
                    ></svg-icon>
                    <div class="check-txt">低风险</div>
                  </div>
                </a-checkbox>
              </div>
            </div>
          </template>
          <div class="m-s-icon td">
            <svg-icon name="fly"></svg-icon>
          </div>
        </a-popover>

        <div class="m-s-zoom">
          <div class="zoom-add" @click.prevent.stop="zoomInViaNavigation">
            <PlusOutlined />
          </div>
          <div class="zoom-minus" @click.prevent.stop="zoomOutViaNavigation">
            <MinusOutlined />
          </div>
        </div>
        <a-popover
          overlayClassName="css-1dowtov"
          placement="leftBottom"
          trigger="hover"
        >
          <div class="m-s-map-icon">
            <div class="select-btn">
              <img :src="mapIcon" />
            </div>
          </div>
          <template #title>{{ "" }}</template>
          <template #content>
            <div class="map-imglayer-data">
              <div class="m-i-d-title">地图实验室
                 <a-switch
                 class="ml5"
              v-model:checked="isShowMask"
              checked-children="掩膜-开启"
              un-checked-children="掩膜-关闭"
            ></a-switch>
              </div>
              <div class="select-imglayer">
                <div
                  class="img-w"
                  :class="{ active: currentLayer === 0 }"
                  @click.stop="
                    handleSettingLayer(0, showImgLayer.includes('img_w_label'))
                  "
                >
                  <div class="img-w-mark">
                    <a-checkbox-group
                      v-model:value="showImgLayer"
                      @change="(val) => handleChangeImgLayer(val, 0)"
                    >
                      <a-checkbox
                        v-for="(dict, index) in layerOptions"
                        :key="dict"
                        :value="dict"
                        v-show="index === 0"
                      ></a-checkbox>
                    </a-checkbox-group>
                    <span> 开启路网 </span>
                  </div>
                  <div class="img-w-name">
                    <span>天地图</span>
                  </div>
                </div>
                <div
                  class="img-w"
                  :class="{ active: currentLayer === 1 }"
                  @click.stop="
                    handleSettingLayer(
                      1,
                      showImgLayer.includes('a_map_img_w_label'),
                    )
                  "
                >
                  <div class="img-w-mark">
                    <a-checkbox-group
                      v-model:value="showImgLayer"
                      @change="(val) => handleChangeImgLayer(val, 1)"
                    >
                      <a-checkbox
                        v-for="(dict, index) in layerOptions"
                        :key="dict"
                        :value="dict"
                        v-show="index === 1"
                      ></a-checkbox>
                    </a-checkbox-group>
                    <span> 开启路网 </span>
                  </div>
                  <div class="img-w-name">
                    <span>高德地图</span>
                  </div>
                </div>
                <div class="img-w" :class="{ active: currentLayer === 3 }" @click.stop="handleSettingLayer(3, showImgLayer.includes('google_img_w_label'))">
                  <div class="img-w-mark">
                    <a-checkbox-group v-model:value="showImgLayer"
                       @change="(val)=>handleChangeImgLayer(val,3)">
                      <a-checkbox v-for="(dict,index) in layerOptions" :key="dict" :value="dict" v-show="index === 3"></a-checkbox>
                      </a-checkbox-group>
                    <span> 开启路网 </span>
                  </div>
                  <div class="img-w-name">
                    <span>google地图</span>
                  </div>
                </div>
                <!-- <div class="img-w" :class="{ active: currentLayer === 2 }" @click.stop="handleSettingLayer(2, showImgLayer.includes('baidu_img_w_label'))">
                  <div class="img-w-mark">
                    <a-checkbox-group v-model:value="showImgLayer"
                       @change="(val)=>handleChangeImgLayer(val,2)">
                      <a-checkbox v-for="(dict,index) in layerOptions" :key="dict" :value="dict" v-show="index === 2"></a-checkbox>
                      </a-checkbox-group>
                    <span> 开启路网 </span>
                  </div>
                  <div class="img-w-name">
                    <span>百度地图</span>
                  </div>
                </div> -->
              </div>
            </div>
          </template>
        </a-popover>
      </div>
    </div>
    <div
      :class="{
        current: showCurrentPoint,
        addCurrent: ['PointLine', 'PolygonPoint', 'PointStrip'].includes(
          state.currentType,
        ),
      }"
      id="cesium-map"
      ref="cesiumContainer"
      class="cesium-map"
    ></div>

    <!-- 测距浮动面板 -->
    <div
      v-if="measureActive && (measurePoints.length > 0 || previewDistance > 0)"
      class="measure-info-panel"
    >
      <div class="measure-header">
        <span>测距</span>
        <CloseOutlined @click="clearMeasure" />
      </div>
      <div class="measure-content">
        <div class="total-distance">
          总距离:
          <strong>{{
            formatDistance(
              measureTotalDistance +
                (measurePoints.length > 0 ? previewDistance : 0),
            )
          }}</strong>
        </div>
        <div v-if="previewDistance > 0" class="current-segment">
          当前段: {{ formatDistance(previewDistance) }}
        </div>
        <div class="measure-tip">左键加点 | 右键/双击清除并退出</div>
      </div>
    </div>
    <a-modal v-model:visible="entityModelVisible" :footer="null" :title="entityModelTitle" :width="'70%'" @cancel="entityModelCancel">
      <div style="width: 100%; height: 730px;">
        <GlbModel ref="modelRef" :currentModelKey="currentModelKey"></GlbModel>
      </div>
    </a-modal>

    <a-modal v-model:visible="photoModelVisible" :footer="null" :width="'70%'" @cancel="photoModelCancel">
      <template #title>
        <div class="orth-head">
          <span>正射影像预览</span>
          <a-tooltip title="下载正射影像">
            <DownloadOutlined @click="downloadOrthophoto(orthophotoDataUrl.modelUrl)" class="orthDownload"/>
          </a-tooltip>
        </div>
      </template>
      <div style="width: 100%; height: 730px; overflow-y: auto;">
        <ProgressiveImage
          v-if="photoModelVisible && orthophotoData && orthophotoData?.tiles?.orthophotoTileId"
          :tile-id="orthophotoData.orthophotoTileId"
          :path="orthophotoData.orthophotoPath"
          :original-width="orthophotoData.orthophotoOriginalWidth"
          :original-height="orthophotoData.orthophotoOriginalHeight"
          :tile-width="orthophotoData.orthophotoTileWidth || 512"
          :tile-height="orthophotoData.orthophotoTileHeight || 512"
          :tiles-x="orthophotoData.orthophotoTilesY"
          :tiles-y="orthophotoData.orthophotoTilesX"
          :tile-urls="tileUrls"
          :container-width="'100%'"
          :auto-load="true"
        />
      </div>
    </a-modal>

    <!--视频分片-->
    <a-modal v-model:visible="videoSegmentVisible" :footer="null" title="延时摄影" :width="'70%'" @cancel="videoSegmentCancel">
      <div style="width: 100%; height: 730px;">
        <div v-if="isLoadingVideoSegments" class="loading-overlay">
          <a-spin tip="加载视频分片中..." />
        </div>
        <video ref="videoPlayerRef" :src="videoSegmentUrls[currentVideoIndex]" autoplay controls style="width: 100%; height: 700px;" @ended="onVideoEnded"/>
      </div>
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import flyContrainer from './cesium/fly_contrainer.vue'
import {
  onMounted,
  ref,
  onBeforeUnmount,
  computed,
  watch,
  nextTick,
  defineAsyncComponent,
  reactive,
  getCurrentInstance,
} from 'vue'
import {
  initCesiumMap,
  getCesiumMap,
  getCesiumDataSource,
  showImgLayer,
  layerOptions,
  handleSettingLayer,
  state as states,
  MapTypeName,
  changeModel,
  state,
  load3DTilesUrl,
  pointCloudModelFn,
  handleShowFlySetting,
  currentLayer,
  sharePane,
} from '/@/hooks/Cesium'
import QrcodeVue from 'qrcode.vue'
import { useMyStore } from '../store'
import * as Cesium from 'cesium'
import { getApp } from '../root'
import { EFlightAreaType } from '../types/flight-area'
import { MapDoodleEnum } from '../types/map-enum'
import { MapDoodleType, MapElementEnum } from '../constants/map'
import emitter from '../event-bus'
import { uuidv4 } from '../utils/uuid'
import moment from 'moment'
import { saveCustomFlightArea } from '../api/flight-area'
import { useRoute, useRouter } from 'vue-router'
import { HomeFilled, CloseOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import mapIcon from '/@/assets/images/map-icon.png'
import { ELocalStorageKey } from '../types'
import {
  currentIndex,
  closeCurrentMedia,
  currentMediaList,
  setCurrent,
  mediaSwitch,
} from '/@/hooks/Cesium/draw-image'
import { postElementsReq, updateElementsReq } from '../api/layer'
import dayjs from 'dayjs'
import ProgressiveImage from '/@/components/ProgressiveImage/index.vue'
import {
  hideModelList,
  keepModelList,
  showModelChange,
  showModelList,
  handleMouseLeave,
  isModelTypeActive,
  getModelTypeDesc,
  expandedTreeNodes,
  selectModelType,
  toggleTreeNode,
  countFolderModels,
  countSubFolderModels,
  countWorkspaceModels,
  countModelTypes,
  loadModelList,
  clearModelType,
} from '../hooks/Cesium/model-draw'
import BorderMaskManager from '../hooks/Cesium/MaskManager'
import { isEdit, removeAddEvent, setAddEvent } from '../utils/kmlParse'
import { getGeoJsons, getTileUrls } from '../api/algCode'
import { getModelsByFolderIdClassification, getUserProjectFolders, getVideoSegmentUrl } from '../api/insp-device.js'
import { clearPointCloudModel, load3DTiles } from '../hooks/archi-model.js'
import { cameraMoveEvent, isMapInited } from '../hooks/Cesium/use-cesium-map.js'
import position from '/@/assets/icons/position.png'
import { secondsToTextBetter } from '../utils/date.js'

const { proxy } = getCurrentInstance()

const MediaView = defineAsyncComponent(
  () => import('/@/components/media/media-view.vue'),
)
const MarkInfo = defineAsyncComponent(
  () => import('/@/components/mark-info/index.vue'),
)
const FlySetting = defineAsyncComponent(
  () => import('/@/components/cesium/fly_setting.vue'),
)
const AirportModal = defineAsyncComponent(
  () => import('/@/components/cesium/airport.vue'),
)
const FlightAreaActionIcon = defineAsyncComponent(
  () => import('./flight-area/FlightAreaActionIcon.vue'),
)
const FlightAreaDrawModal = defineAsyncComponent(
  () => import('./flight-area/FlightAreaDrawModal.vue'),
)
const GActionType = defineAsyncComponent(
  () => import('/@/components/cesium/g-action-type.vue'),
)
const route = useRoute()
const router = useRouter()
const cesiumContainer = ref(null)
const viewer = ref<Cesium.Viewer | null>(null)
const mapDataSource = ref(null)
const drawings = ref([])
const store = useMyStore()
const mouseMode = ref(false)
const isFlightArea = ref(false)

const mask = ref(null)
const xinLongMask = ref(null)
const optionsMask = ref({
  borderColor: Cesium.Color.BLACK,
  borderWidth: 3,
  enableGlow: false,
  glowPower: 0.1,
  // maskShow: false,
  // maskOpacity: 0.9, // 区域外掩膜透明度
  // maskColor: Cesium.Color.BLACK, // 区域外掩膜颜色
})
const xinglongMaskList = reactive({})
const showDrawModal = ref(false)
const currentAreaData = ref<any>({})
const tempEntityId = ref<string>('')
const isFlightAreaRouter = computed(() => route.path.includes('flight-area'))
const isSettingPlanar = computed(
  () => route.path.indexOf('/wayline-edit-planar') > -1,
)
const isSettingStrip = computed(
  () => route.path.indexOf('/wayline-edit-strip') > -1,
)
const isDataUi = computed(() => route.path.indexOf('/dataUi') > -1)
const dataCenter = computed(() => store.state.datacenter)
const isWaylineEdit = computed(
  () =>
    route.path.indexOf('/wayline-edit') > -1 ||
    route.path.indexOf('/wayline-edit-strip') > -1 ||
    route.path.indexOf('/wayline-edit-planar') > -1,
)
const username = localStorage.getItem(ELocalStorageKey.Username) || ''
const notieList = computed(() => store.state.notieList)
const getActive = computed(() => !store.state.headerVisible)
const shareId = computed(() => store.state.layerBaseInfo.share)
const isFlyArea = computed(() => store.state.isFlyArea)
const isCustumFlyArea = computed(() => store.state.isCustumFlyArea)
const flyErrorStatus = computed(() => store.state.flyErrorStatus)
const flyWarningStatus = computed(() => store.state.flyWarningStatus)
const flyPrimaryStatus = computed(() => store.state.flyPrimaryStatus)
const waylineInfo = computed(() => store.state.waylineInfo)
const workspaceList = computed(() => store.state.workspaceList || [])
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId) || ''
const is_waylineTemplate = computed(() => store.state.waylineTemplate)
const is_waylineDevice = computed(() => store.state.waylineDevice)
const FlightSimulationFlag = computed(() => store.state.FlightSimulationFlag)
const isShowMask = computed({
  get: () => store.state.isShowMask,
  set: (val) => {
    store.commit('SET_SHOW_MASK', val)
    handleShowMask(val)
  },
})

const showPointCloud = computed({
  get: () => store.state.showPointCloud,
  set: (val) => {
    store.commit('SET_POINT_CLOUD', val)
    handleChangePointCloud(val)
  },
})
const showModelTileset = computed({
  get: () => store.state.showModelTileset,
  set: (val) => {
    store.commit('SET_MODEL_TILESET', val)
    handleChangeTitleset(val)
  },
})
const lon_text = ref(0)
const lat_text = ref(0)
const point = ref()

const handleVisible = (val) => {
  if (!val) {
    if (point.value) {
      viewer.value?.entities.remove(point.value)
      point.value = null
    }
  }
}

const locate = () => {
  if (!lon_text.value) {
    message.error('请输入经度')
    return
  }
  if (!lat_text.value) {
    message.error('请输入纬度')
    return
  }
  const center = Cesium.Cartesian3.fromDegrees(lon_text.value, lat_text.value, 1000)
  if (point.value) {
    viewer.value?.entities.remove(point.value)
    point.value = null
  }
  point.value = viewer.value?.entities.add({
    position: Cesium.Cartesian3.fromDegrees(lon_text.value, lat_text.value),
    billboard: {
      image: position,
      width: 32,
      height: 32,
      verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      pixelOffset: new Cesium.Cartesian2(0, -50),
      disableDepthTestDistance: Number.POSITIVE_INFINITY,
    }
  })
  viewer.value?.camera.flyTo({
    destination: center,
    duration: 1.5
  })
}

export interface FlightAreaDrawData {
  id: string;
  name: string;
  type: 'circle' | 'polygon';
  coordinates: any[];
  radius?: number;
  area: number;
  color: string;
  drawer?: string;
}

const showEditRouter = computed(() => store.state.showEditRouter)

// ================= 测距功能（带鼠标移动预览） =================
const measureActive = ref(false)
const measurePoints = ref([]) // 存储固定的点 (Cartesian3)
const measureEntities = ref([]) // 永久实体（点、线、中点标签）
const tempEntities = ref([]) // 临时预览实体（线、点、标签）
const measureTotalDistance = ref(0) // 固定线段总距离
const previewDistance = ref(0) // 当前预览段距离
let measureHandler = null // 事件处理器

// 格式化距离
const formatDistance = (meters) => {
  if (meters >= 1000) return `${(meters / 1000).toFixed(2)} km`
  return `${meters.toFixed(2)} m`
}

// 计算两点间距离（米）
const computeDistance = (p1, p2) => Cesium.Cartesian3.distance(p1, p2)

// 获取鼠标点击/移动时的地表坐标
const getMousePosition = (movement) => {
  if (!viewer.value) return null
  const ray = viewer.value.camera.getPickRay(
    movement.position || movement.endPosition,
  )
  if (!ray) return null
  // 优先获取地形交点
  let position = viewer.value.scene.globe.pick(ray, viewer.value.scene)
  if (!position) {
    // 如果没有地形，则获取椭球面交点
    position = viewer.value.camera.pickEllipsoid(
      movement.position || movement.endPosition,
    )
  }
  return position
}

// 清除所有永久实体
const clearPermanentEntities = () => {
  measureEntities.value.forEach((entity) =>
    viewer.value?.entities.remove(entity),
  )
  measureEntities.value = []
}

// 清除所有临时预览实体
const clearTempEntities = () => {
  tempEntities.value.forEach((entity) => viewer.value?.entities.remove(entity))
  tempEntities.value = []
}

// 更新永久图形（固定点之间的线段、点、中点标签）
const updatePermanentGraphics = () => {
  if (!viewer.value) return
  clearPermanentEntities()
  if (measurePoints.value.length === 0) return

  // 添加固定点
  measurePoints.value.forEach((point, idx) => {
    const pointEntity = viewer.value.entities.add({
      position: point,
      point: {
        pixelSize: 8,
        color: Cesium.Color.LIME,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
      },
      label: {
        text: idx === 0 ? '起点' : `点${idx + 1}`,
        font: '14px sans-serif',
        fillColor: Cesium.Color.WHITE,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        pixelOffset: new Cesium.Cartesian2(10, -10),
      },
    })
    measureEntities.value.push(pointEntity)
  })

  if (measurePoints.value.length < 2) return

  // 绘制折线
  const polyline = viewer.value.entities.add({
    polyline: {
      positions: measurePoints.value,
      width: 4,
      material: Cesium.Color.fromCssColorString('#1890ff'),
      arcType: Cesium.ArcType.GEODESIC,
      clampToGround: false,
    },
  })
  measureEntities.value.push(polyline)

  // 计算总距离并添加中点距离标签
  let total = 0
  for (let i = 1; i < measurePoints.value.length; i++) {
    const segDist = computeDistance(
      measurePoints.value[i - 1],
      measurePoints.value[i],
    )
    total += segDist
    const midpoint = Cesium.Cartesian3.midpoint(
      measurePoints.value[i - 1],
      measurePoints.value[i],
      new Cesium.Cartesian3(),
    )
    const label = viewer.value.entities.add({
      position: midpoint,
      label: {
        text: formatDistance(segDist),
        font: '12px sans-serif',
        fillColor: Cesium.Color.YELLOW,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        backgroundColor: Cesium.Color.fromCssColorString('rgba(0,0,0,0.7)'),
        showBackground: true,
        pixelOffset: new Cesium.Cartesian2(0, -15),
      },
    })
    measureEntities.value.push(label)
  }
  measureTotalDistance.value = total
}

// 更新临时预览（从最后一个固定点到鼠标位置）
const updatePreview = (mouseCartesian) => {
  clearTempEntities()
  if (!mouseCartesian || measurePoints.value.length === 0) {
    previewDistance.value = 0
    return
  }

  const lastPoint = measurePoints.value[measurePoints.value.length - 1]
  const segDist = computeDistance(lastPoint, mouseCartesian)
  previewDistance.value = segDist

  // 预览线段（使用橙色，虚线效果）
  const previewLine = viewer.value.entities.add({
    polyline: {
      positions: [lastPoint, mouseCartesian],
      width: 4,
      material: new Cesium.PolylineDashMaterialProperty({
        color: Cesium.Color.fromCssColorString('#ffaa00'),
        dashLength: 16.0,
        gapColor: Cesium.Color.TRANSPARENT,
      }),
      arcType: Cesium.ArcType.GEODESIC,
      clampToGround: false,
    },
  })
  tempEntities.value.push(previewLine)

  // 预览点（橙色）
  const previewPoint = viewer.value.entities.add({
    position: mouseCartesian,
    point: {
      pixelSize: 8,
      color: Cesium.Color.ORANGE,
      outlineColor: Cesium.Color.BLACK,
      outlineWidth: 2,
    },
    label: {
      text: '预览点',
      font: '12px sans-serif',
      fillColor: Cesium.Color.WHITE,
      outlineColor: Cesium.Color.BLACK,
      outlineWidth: 2,
      pixelOffset: new Cesium.Cartesian2(10, -10),
    },
  })
  tempEntities.value.push(previewPoint)

  // 预览距离标签（位于线段中点）
  const midpoint = Cesium.Cartesian3.midpoint(
    lastPoint,
    mouseCartesian,
    new Cesium.Cartesian3(),
  )
  const previewLabel = viewer.value.entities.add({
    position: midpoint,
    label: {
      text: formatDistance(segDist),
      font: '14px sans-serif',
      fillColor: Cesium.Color.WHITE,
      outlineColor: Cesium.Color.BLACK,
      outlineWidth: 2,
      backgroundColor: Cesium.Color.fromCssColorString('rgba(0,0,0,0.7)'),
      showBackground: true,
      pixelOffset: new Cesium.Cartesian2(0, -20),
    },
  })
  tempEntities.value.push(previewLabel)
}

// 添加固定点（左键点击时调用）
const addFixedPoint = (cartesian) => {
  measurePoints.value.push(cartesian)
  updatePermanentGraphics()
  // 添加点后清除预览，等待下一次移动事件重新生成
  clearTempEntities()
  previewDistance.value = 0
}

// 激活测距模式
const activateMeasureMode = () => {
  if (!viewer.value) return
  // 关闭其他绘制模式
  if (states.isDraw) {
    states.drawTool?.stopDrawing()
    states.currentType = null
    states.isDraw = false
  }
  if (mouseMode.value) draw('off', false)
  if (states.drawRouteTool) states.drawRouteTool.stopDrawing()
  if (states.drawCircleTool) states.drawCircleTool.endDraw()

  measureActive.value = true
  measurePoints.value = []
  clearPermanentEntities()
  clearTempEntities()
  measureTotalDistance.value = 0
  previewDistance.value = 0

  // 改变鼠标样式
  viewer.value.canvas.style.cursor = 'crosshair'

  // 创建事件处理器
  measureHandler = new Cesium.ScreenSpaceEventHandler(viewer.value.canvas)

  // 左键添加固定点
  measureHandler.setInputAction((movement) => {
    const pos = getMousePosition(movement)
    if (pos) addFixedPoint(pos)
  }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

  // 右键或双击清除并退出
  measureHandler.setInputAction(() => {
    deactivateMeasureMode()
  }, Cesium.ScreenSpaceEventType.RIGHT_CLICK)
  measureHandler.setInputAction(() => {
    deactivateMeasureMode()
  }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)

  // 鼠标移动时更新预览
  measureHandler.setInputAction((movement) => {
    if (measurePoints.value.length === 0) return
    const pos = getMousePosition(movement)
    if (pos) {
      updatePreview(pos)
    } else {
      clearTempEntities()
      previewDistance.value = 0
    }
  }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
}

// 退出测距模式
const deactivateMeasureMode = () => {
  if (!viewer.value) return
  if (measureHandler) {
    measureHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK)
    measureHandler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK)
    measureHandler.removeInputAction(
      Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK,
    )
    measureHandler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE)
    measureHandler = null
  }
  viewer.value.canvas.style.cursor = ''
  clearPermanentEntities()
  clearTempEntities()
  measurePoints.value = []
  measureTotalDistance.value = 0
  previewDistance.value = 0
  measureActive.value = false
}

// 清除测距（同时退出模式）
const clearMeasure = () => {
  if (measureActive.value) deactivateMeasureMode()
  else {
    clearPermanentEntities()
    clearTempEntities()
    measurePoints.value = []
    measureTotalDistance.value = 0
    previewDistance.value = 0
  }
}

// 切换测距模式（按钮调用）
const toggleMeasureDistance = () => {
  if (measureActive.value) deactivateMeasureMode()
  else activateMeasureMode()
}
// ================= 测距功能结束 =================

function handleChangeImgLayer (val: string[], number: number) {
  nextTick(() => {
    handleSettingLayer(number, val.includes(layerOptions[number]))
  })
}

function handleChangePointCloud (val: boolean) {
  nextTick(() => {
    clearModelType()
    pointCloudModelFn()
  })
}
function handleChangeTitleset (val: boolean) {
  nextTick(() => {
    clearModelType()
    pointCloudModelFn()
  })
}
function handleChangeCheckChange (key: string, flag: boolean) {
  if (key === 'flyErrorStatus') {
    store.commit('SET_FLY_ERROR_STATUS', flag)
  } else if (key === 'flyWarningStatus') {
    store.commit('SET_FLY_WARNING_STATUS', flag)
  } else if (key === 'flyPrimaryStatus') {
    store.commit('SET_FLY_PRIMARY_STATUS', flag)
  }
}
function handleSwitchChange (val) {
  store.commit('SET_FLY_AREA_FLAG', val)
  const list = store.state.custumFlyList
  list.forEach((item) => {
    item.show = val
  })
  store.commit('SET_CUSTUM_FLY_LIST', list)
  state.drawFlightArea?.setCircleList(list)
}
function handleSwitchCustumChange (val) {
  store.commit('SET_CUSTUM_FLY_AREA_FLAG', val)
  const list = store.state.crawlerList
  list.forEach((item) => {
    item.status = val
  })
  store.commit('SET_CRAWLER_LIST', list)
  state.drawFlightArea?.setApiListStatusChange(list, val)
  console.log(list, val, 'handleSwitchCustumChange')
}
function drawCesium (type: string) {
  if (type === 'PointLine' && isEdit.value) return

  // 如果测距模式激活，先关闭测距
  if (measureActive.value) {
    deactivateMeasureMode()
  }
  const startPoint = store.state.routeStartPosition
  if (type === 'PointLine' && !startPoint) {
    message.error('请先选择起始点')
    return
  }
  if (isFlightArea.value) {
    state.drawFlightArea?.clearDrawEntity()
    state.rightClick = false
  }
  if (states.isDraw) {
    states.drawTool?.stopDrawing()
  }
  if (!states.currentType || states.currentType !== type) {
    states.currentType = type
    states.isDraw = true
    const json = localStorage.getItem('editWayline')
    if (type === 'PointLine') {
      if (json) {
        states.drawRouteTool?.drawDrawPointLine()
        setAddEvent()
      } else {
        states.drawRouteTool?.activate()
      }
    } else if (type === 'Circle') {
      states.drawCircleTool?.startDraw()
    } else {
      states.drawTool?.activate(type)
    }
  } else {
    states.currentType = null
    states.isDraw = false
    states.drawRouteTool?.stopDrawing()
    states.drawTool?.stopDrawing()
    states.drawCircleTool?.endDraw()
    removeAddEvent()
  }
}
const showCurrentPoint = computed(() => store.state.startPointFlag)
function zoomInViaNavigation () {
  states.drawTool?.zoomInViaNavigation()
}
function zoomOutViaNavigation () {
  states.drawTool?.zoomOutViaNavigation()
}
function handleChangeModel () {
  changeModel(MapTypeName[states.mapType])
}
const FlightAreaType = {
  Point: MapElementEnum.PIN,
  Polyline: MapElementEnum.LINE,
  Polygon: MapElementEnum.POLY,
  Circle: 3,
}
function getDrawMarkCallback (obj: any) {
  if (states.currentType) {
    console.log(obj, 'obj')
    const saveData = {
      id: uuidv4(),
      name: `${state.currentType}-${shareId.value}-${moment().format('YYYY-MM-DD HH:mm')}`,
      resource: {
        type: FlightAreaType[state.currentType],
        content: {
          type: 'Feature',
          properties: {
            color: obj.color,
            clampToGround: false,
          },
          geometry: {
            radius: obj.radius || 0,
            coordinates: obj.position,
            type:
              state.currentType === 'Polyline'
                ? 'LineString'
                : state.currentType,
          },
        },
        user_name: username,
      },
    }
    postElementsReq(shareId.value, saveData).then((res) => {
      if (res.code === 0) {
        const list = store.state.markList
        const index = list.findIndex((el) => el.id === saveData.id)
        if (index >= 0) {
          list.splice(index, 1, saveData)
          store.commit('SET_MARK_LIST', list)
        } else {
          list.push(saveData)
          store.commit('SET_MARK_LIST', list)
        }
        state.drawTool?.addAPIResponseGraphic(saveData)
        nextTick(() => {
          const drawing = state.drawTool?.getDrawingById(saveData.id)
          if (drawing) {
            state.drawTool?.selectDrawing(drawing)
          }
        })
        store.commit('SET_MARK_CURRENT', {
          ...saveData,
          type: state.currentType,
        })
      }
    })
  }
}

function getDrawCallback (obj: any) {
  if (isFlightArea.value) {
    // 计算面积和半径
    let area = 0
    let radius = 0
    let coordinates = []

    if (state.currentType === 'circle') {
      // 圆形区域
      radius = obj.radius || 0
      area = calculateCircleArea(radius)
      coordinates = obj.center || []
    } else {
      // 多边形区域
      coordinates = obj.coordinates || obj.latlngList || [] // 修正：使用 coordinates 而不是 latlngList
      area = calculatePolygonArea(coordinates)
    }

    // 保存临时实体ID，用于取消时删除
    tempEntityId.value = obj.entity?.id || ''
    const workspace_id =
      store.state.customWorkspace ||
      workspaceId ||
      workspaceList.value[0].workspace_id ||
      ''

    // 设置当前区域数据
    currentAreaData.value = {
      id: uuidv4(),
      name: `${obj.color === '#19be6b' ? 'dfence' : 'nfz'}-${moment().format('YYYY-MM-DD HH:mm')}`,
      type: state.currentType,
      coordinates: coordinates,
      radius: radius,
      area: area,
      color: obj.color,
      drawer: username,
      workspace_id: workspace_id,
    }

    // 显示弹层
    showDrawModal.value = true
    state.drawFlightArea.removeEntity(tempEntityId.value)
  }
}

// 计算圆形面积
function calculateCircleArea (radius: number): number {
  return Math.PI * radius * radius
}

// 计算多边形面积（使用Cesium的面积计算方法）
function calculatePolygonArea (coordinates: number[][]): number {
  if (!coordinates || coordinates.length === 0 || coordinates[0].length < 3) {
    return 0
  }

  try {
    const ring = coordinates[0]
    // 将经纬度坐标转换为笛卡尔坐标
    const cartesians = ring.map((coord) => {
      return Cesium.Cartesian3.fromDegrees(coord[0], coord[1], coord[2] || 0)
    })

    const area = Cesium.Ellipsoid.WGS84.geodesicArea(cartesians)

    // 计算多边形面积
    // return Cesium.PolygonGeometry.computeArea(cartesians)
    return Math.abs(area)
  } catch (error) {
    if (coordinates[0] && coordinates[0].length > 2) {
      return calculateSimplePolygonArea(coordinates[0])
    }
    return 0
  }
}

function calculateSimplePolygonArea (ring: number[][]): number {
  let area = 0
  const R = 6371000 // 地球半径（米）
  const length = ring.length

  if (length < 3) return 0

  // 将经纬度转换为弧度
  const coords = ring.map((coord) => {
    const lon = (coord[0] * Math.PI) / 180
    const lat = (coord[1] * Math.PI) / 180
    const h = coord[2] || 0
    return { lon, lat, h }
  })

  // 使用球面三角形面积公式（Girard's theorem）
  for (let i = 0; i < length; i++) {
    const j = (i + 1) % length

    area +=
      (coords[j].lon - coords[i].lon) *
      (2 + Math.sin(coords[i].lat) + Math.sin(coords[j].lat))
  }

  area = Math.abs((area * R * R) / 2)
  return area
}

// 处理弹层确认
function handleAreaConfirm (saveData: any) {
  const type =
    saveData.color !== '#19be6b' ? EFlightAreaType.NFZ : EFlightAreaType.DFENCE
  if (saveData.type !== 'circle') {
    saveData.coordinates[0].push(saveData.coordinates[0][0])
  }
  const saveGeo = {
    id: saveData.id,
    name: saveData.name,
    type: type,
    content: {
      properties: {
        color: saveData.color,
        clampToGround: false,
        drawer: username, // 添加绘制者信息
        area: saveData.area, // 添加面积信息
        radius: saveData.radius, // 添加半径信息
      },
      geometry: {
        coordinates: saveData.coordinates,
        radius: saveData.radius,
        type: saveData.type === 'circle' ? 'Circle' : 'Polygon',
      },
      type: 'Feature',
    },
  }

  saveCustomFlightArea(saveGeo, saveData.areaWork)
    .then((res) => {
      if (res.code !== 0) {
        message.error('保存失败')
        // 保存失败时删除实体
        state.drawFlightArea.removeEntity(tempEntityId.value)
      } else {
        message.success('保存成功')
        if (!route.path.includes('flight-area')) {
          if (saveData.type === 'circle') {
            state.drawFlightArea?.setCircleInfo(saveGeo.content, saveGeo)
          } else {
            state.drawFlightArea?.setPolygonInfo(saveGeo.content, saveGeo)
          }
        }
      }
    })
    .finally(() => {
      state.drawFlightArea.removeEntity(tempEntityId.value)
      // 清理临时实体
      tempEntityId.value = ''
      showDrawModal.value = false
      store.dispatch('getCustumFlyList', '')
      emitter.emit('updateFlightArea')
    })
}

// 处理弹层取消
function handleAreaCancel () {
  // 取消时删除临时绘制的实体
  if (tempEntityId.value) {
    state.drawFlightArea?.removeEntity(tempEntityId.value)
    tempEntityId.value = ''
  }
  showDrawModal.value = false
}

function draw (
  type: MapDoodleType,
  bool: boolean,
  flightAreaType?: EFlightAreaType,
) {
  state.currentType = type
  mouseMode.value = bool
  isFlightArea.value = !!flightAreaType
  state.drawFlightArea?.clearDrawEntity()
  if (type === 'circle') {
    if (isFlightArea.value) {
      state.drawFlightArea?.setDrawColor(
        flightAreaType === EFlightAreaType.DFENCE ? '#19be6b' : '#FF4949',
      )
      state.drawFlightArea?.startDrawCircle()
    } else {
      state.drawFlightArea?.clearDrawEntity()
    }
  } else if (type === 'polygon') {
    if (isFlightArea.value) {
      state.rightClick = true
      state.drawFlightArea?.setDrawColor(
        flightAreaType === EFlightAreaType.DFENCE ? '#19be6b' : '#FF4949',
      )
      state.drawFlightArea?.startDrawPolygon()
    } else {
      state.drawFlightArea?.clearDrawEntity()
    }
  } else if (type === 'off') {
    state.drawFlightArea?.clearDrawEntity()
    state.rightClick = false
  }
}

/**
 * 选择航班区域的操作函数
 *
 * @param options 包含类型与是否为圆形的对象
 * @param options.type 航班区域类型
 * @param options.isCircle 是否为圆形
 */
function selectFlightAreaAction ({
  type,
  isCircle,
}: {
  type: EFlightAreaType;
  isCircle: boolean;
}) {
  draw(isCircle ? MapDoodleEnum.CIRCLE : MapDoodleEnum.POLYGON, true, type)
}
function handleToPath () {
  router.push({ path: '/notieDetail' })
}

// 添加建筑相关的状态
const showBuildingControls = ref(false)
const selectedBuildingLayer = ref('')
const customTilesetUrl = ref('')
const currentBuildingTileset = ref<any>(null)
const buildingsVisible = ref(false)
const loadProgress = ref(0)
const memoryUsage = ref(0)
const buildingError = ref('')

// 处理建筑图层切换
const handleBuildingLayerChange = async (value: string) => {
  buildingError.value = ''
  if (value === 'osm') {
    await loadOSMBuildingLayer()
  } else if (value === 'test') {
    await loadTestBuilding()
  }
}

// 加载OSM建筑（带错误处理）
const loadOSMBuildingLayer = async () => {
  try {
    // 先移除现有的建筑
    if (currentBuildingTileset.value) {
      currentBuildingTileset.value.destroy()
      currentBuildingTileset.value = null
    }

    // 尝试不同的数据源
    let result = null

    try {
      // 首先尝试ArcGIS的免费数据源
      result = await load3DTilesUrl(
        'https://tiles.arcgis.com/tiles/P3ePLMYs2RVChkJx/arcgis/rest/services/Buildings_NewYork/SceneServer/layers/0',
        {
          position: { lng: 113.453275, lat: 23.185216 }, // 使用广州坐标
          scale: 0.8,
          maximumScreenSpaceError: 12,
        },
      )
    } catch (arcgisError) {
      console.warn('ArcGIS数据源加载失败，尝试本地数据:', arcgisError)

      // 如果ArcGIS失败，尝试加载本地测试数据
      result = await loadTestBuilding()
    }

    if (result) {
      currentBuildingTileset.value = result
      buildingsVisible.value = true

      // 如果是3D Tiles，添加加载进度监听
      if (result.tileset) {
        result.tileset.tileLoad.addEventListener((tile: any) => {
          if (result.tileset) {
            const tilesLoaded = result.tileset.tilesLoaded.length
            const totalTiles =
              result.tileset.tilesLoaded.length +
              result.tileset.tilesProcessing.length
            loadProgress.value = Math.round((tilesLoaded / totalTiles) * 100)

            // 更新内存使用
            memoryUsage.value = Math.round(
              result.tileset.totalMemoryUsageInBytes / (1024 * 1024),
            )
          }
        })
      }

      message.success('建筑模型加载成功')
    }
  } catch (error: any) {
    console.error('加载建筑失败:', error)
    buildingError.value = error.message || '加载建筑模型失败'
    message.error(buildingError.value)

    // 提供一个备选方案
    if (
      error.message.includes('网络请求失败') ||
      error.message.includes('CORS')
    ) {
      buildingError.value +=
        '。建议：1) 检查网络连接 2) 使用本地数据源 3) 配置代理服务器'
    }
  }
}

// 加载测试建筑（备选方案）
const loadTestBuilding = async () => {
  try {
    if (currentBuildingTileset.value) {
      currentBuildingTileset.value.destroy()
      currentBuildingTileset.value = null
    }

    const result = await loadTestBuilding()
    // if (result) {
    //   const initialPosition = Cesium.Cartesian3.fromDegrees(
    //     -74.01881302800248,
    //     40.69114333714821,
    //     753,
    //   )
    //   const initialOrientation = Cesium.HeadingPitchRoll.fromDegrees(
    //     21.27879878293835,
    //     -21.34390550872461,
    //     0.0716951918898415,
    //   )
    //   viewer.value.scene.camera.setView({
    //     destination: initialPosition,
    //     orientation: initialOrientation,
    //     endTransform: Cesium.Matrix4.IDENTITY,
    //   })
    //   currentBuildingTileset.value = result
    //   buildingsVisible.value = true
    //   loadProgress.value = 100
    //   memoryUsage.value = 0
    //   message.info('测试建筑加载成功（这是一个示例）')
    // }
    if (result) {
      currentBuildingTileset.value = result
      buildingsVisible.value = true
      loadProgress.value = 100
      memoryUsage.value = 0
      message.info('测试建筑加载成功（这是一个示例）')
    }
  } catch (error: any) {
    buildingError.value = error.message || '加载测试建筑失败'
    message.error(buildingError.value)
  }
}

// 加载自定义建筑
const loadCustomBuildings = async () => {
  if (!customTilesetUrl.value.trim()) {
    message.warning('请输入3D Tiles URL')
    return
  }

  try {
    if (currentBuildingTileset.value) {
      currentBuildingTileset.value.destroy()
    }
    buildingError.value = ''
    const result = await load3DTilesUrl(customTilesetUrl.value.trim(), {
      skipTransform: true,
      // position: { lng: states.position.longitude, lat: states.position.latitude },
      // scale: 1.0
    })

    if (result) {
      currentBuildingTileset.value = result
      buildingsVisible.value = true
      message.success('自定义建筑模型加载成功')
    }
  } catch (error: any) {
    console.error('加载自定义建筑失败:', error)
    buildingError.value = error.message || '加载自定义建筑模型失败'
    message.error(buildingError.value)
  }
}

// 切换建筑显示/隐藏
const toggleBuildings = () => {
  if (currentBuildingTileset.value) {
    buildingsVisible.value = !buildingsVisible.value
    if (currentBuildingTileset.value.tileset) {
      currentBuildingTileset.value.tileset.show = buildingsVisible.value
    } else if (currentBuildingTileset.value.entity) {
      currentBuildingTileset.value.entity.show = buildingsVisible.value
    }
  }
}

// 移除建筑
const removeBuildings = () => {
  if (currentBuildingTileset.value) {
    currentBuildingTileset.value.destroy()
    currentBuildingTileset.value = null
    buildingsVisible.value = false
    loadProgress.value = 0
    memoryUsage.value = 0
    buildingError.value = ''
    message.info('建筑模型已移除')
  }
}
const getDrawGraphicUpdatedCallback = (graphic) => {
  const { positions } = graphic
  const latlng = positions.map((item) => [item.longitude, item.latitude, 0])
  if (graphic.resource.content.geometry.type === 'Circle') {
    graphic.resource.content.geometry.coordinates = latlng[0]
  } else {
    graphic.resource.content.geometry.coordinates = latlng
  }
  const pointSave = { ...graphic }
  pointSave.content = graphic.resource.content
  delete pointSave.resource
  state.drawTool.restoreCameraSettings()
  updateElementsReq(graphic.id, pointSave)
  nextTick(() => {
    state.drawTool?.selectDrawingById(graphic.id)
    if (graphic.resource.content.geometry.type === 'Circle') {
      store.commit('SET_CURRENT_CIRCLE', { ...graphic })
    } else if (graphic.resource.content.geometry.type === 'Polygon') {
      store.commit('SET_CURRENT_POLYGON', { ...graphic })
    } else if (graphic.resource.content.geometry.type === 'Polyline') {
      store.commit('SET_CURRENT_POLYLINE', { ...graphic })
    } else if (graphic.resource.content.geometry.type === 'Point') {
      store.commit('SET_CURRENT_POINT', { ...graphic })
    }
  })
}

const getGeoJson = () => {
  getGeoJsons().then((res) => {
    console.log(res, 'res')
    if (res.code === 0) {
      const geoJsonData = res.data
      console.log(geoJsonData, 'geoJsonData')
      geoJsonData.forEach((element) => {
        if (element.areaCode === '440112') return
        const data = JSON.parse(element.geometry)
        element.geometry = data
        const feacture = {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: data,
              properties: {
                name: element.name,
                cun_code: element.areaCode,
              },
            },
          ],
        }
        xinglongMaskList[element.areaCode] = {
          path: null,
          data: feacture,
          options: optionsMask.value,
          mask: null,
        }
      })
    }
  })
}

const folderList = ref<any[]>([])
const folderCategoryData = ref<Record<number, any>>({})
const expandedKeys = ref<string[]>([])
const selectedModelKeys = ref<string[]>([])
const modelCheckedKeys = ref<string[]>([])
const loadedTilesetsMap = ref<Record<string, any>>({}) // 存储已加载的 tileset 对象

// 递归构建树节点
const buildFolderTree = (folders: any[], parentKeyPrefix: string): any[] => {
  return folders.map(folder => {
    const folderKey = `${parentKeyPrefix}-${folder.id}`
    const isLeaf = !folder.children || folder.children.length === 0

    const folderNode: any = {
      title: folder.folderName || folder.name || folder.title,
      key: folderKey,
      dataRef: folder,
      selectable: false,
      checkable: false,
      children: []
    }

    if (folder.children && folder.children.length > 0) {
      folderNode.children = buildFolderTree(folder.children, folderKey)
    }

    if (isLeaf) {
      const categoryData = folderCategoryData.value[folder.id] || {}
      const typeConfig = {
        cloud: { label: '点云模型' },
        model: { label: '实体模型' },
        b3dm: { label: '地图模型' },
        orthophoto: { label: '正射影像' },
        timeLapse: { label: '延时摄影' }
      }

      for (const [typeKey, config] of Object.entries(typeConfig)) {
        const typeData = categoryData[typeKey]
        if (!typeData || (typeof typeData === 'object' && Object.keys(typeData).length === 0)) continue

        const typeNode: any = {
          title: `${config.label}`,
          key: `type-${folder.id}-${typeKey}`,
          selectable: false,
          checkable: false,
          children: []
        }

        if (typeof typeData === 'object') {
          for (const version in typeData) {
            const models = typeData[version]
            if (!Array.isArray(models) || models.length === 0) continue

            const versionNode: any = {
              title: version,
              key: `version-${folder.id}-${typeKey}-${version}`,
              selectable: false,
              checkable: false,
              children: []
            }

            models.forEach((model, idx) => {
              const modelId = model.id || `${folder.id}-${typeKey}-${idx}`
              const modelName = model.modelName || model.name || '未命名模型'
              const menuItems = buildModelMenuItems(model, typeKey, folder.id, modelId, modelName)

              if (menuItems.length === 1) {
                versionNode.children.push(menuItems[0])
              } else if (menuItems.length > 1) {
                versionNode.children.push({
                  title: modelName,
                  key: `${modelId}-parent`,
                  selectable: false,
                  checkable: false,
                  children: menuItems
                })
              }
            })

            if (versionNode.children.length > 0) {
              typeNode.children.push(versionNode)
            }
          }
        }

        if (typeNode.children.length > 0) {
          folderNode.children.push(typeNode)
        }
      }

      if (folderNode.children.length === 0) {
        folderNode.children.push({
          title: '暂无可用数据',
          key: `${folderKey}-empty`,
          isLeaf: true,
          disabled: true,
          selectable: false,
          checkable: false,
        })
      }
    }

    return folderNode
  })
}

// 构建模型菜单项
function buildModelMenuItems (model: any, typeKey: string, folderId: number, modelId: string, modelName: string) {
  const menuItems: any[] = []

  switch (typeKey) {
    case 'cloud':
      if (model.modelUrl) {
        menuItems.push({
          title: model.region || '点云模型',
          key: `${modelId}-pointCloud`,
          isLeaf: true,
          selectable: true,
          checkable: true,
          type: 'pointCloud',
          dataRef: { ...model, folderId, type: 'pointCloud', url: model.modelUrl }
        })
      }
      break
    case 'model': {
      if (model.modelUrl) {
        const isPly = model.model3dType === 'ply'
        const title = isPly ? (model.region || '高斯模型') : (model.region || '3D实体模型')
        menuItems.push({
          title: title,
          key: `${modelId}-model3d`,
          isLeaf: true,
          selectable: true,
          checkable: false,
          type: isPly ? 'ply' : 'model3d',
          dataRef: { ...model, folderId, type: isPly ? 'ply' : 'model3d', url: model.modelUrl }
        })
      }
      break
    }
    case 'b3dm':
      if (model.modelUrl) {
        menuItems.push({
          title: model.region || '地图模型',
          key: `${modelId}-b3dm`,
          isLeaf: true,
          selectable: true,
          checkable: true,
          type: 'b3dm',
          dataRef: { ...model, folderId, type: 'b3dm', url: model.modelUrl }
        })
      }
      break
    case 'orthophoto':
      if (model.tiles) {
        menuItems.push({
          title: model.region || '正射影像(瓦片)',
          key: `${modelId}-orthophoto-tiles`,
          isLeaf: true,
          selectable: true,
          checkable: false,
          type: 'orthophoto',
          dataRef: { ...model, folderId, type: 'orthophoto', useTiles: true }
        })
      } else if (model.modelUrl) {
        menuItems.push({
          title: model.region || '正射影像(原图)',
          key: `${modelId}-orthophoto`,
          isLeaf: true,
          selectable: true,
          checkable: false,
          type: 'orthophoto',
          dataRef: { ...model, folderId, type: 'orthophoto', url: model.modelUrl }
        })
      }
      break
    case 'timeLapse':
      if (model.videoUrl || model.videoSliceResult) {
        menuItems.push({
          title: model.region || '延时摄影',
          key: `${modelId}-videoSlice`,
          isLeaf: true,
          selectable: true,
          checkable: false,
          type: 'videoSlice',
          dataRef: { ...model, folderId, type: 'videoSlice' }
        })
      }
      break
  }
  return menuItems
}

// 加载模型到地图
const loadTilesetToMap = async (model: any, type: string, key: string) => {
  if (!model.url || loadedTilesetsMap.value[key]) return
  const isPointCloud = type === 'pointCloud'
  try {
    const result = await load3DTiles(model.url, {
      skipTransform: true,
      position: { lng: state.position.longitude, lat: state.position.latitude },
      scale: 1.0,
      show: true,
      loadPointCloud: isPointCloud,
      loadModel: !isPointCloud,
      maximumScreenSpaceError: 1,
    })
    if (result && result.tilesets && result.tilesets.length > 0) {
      loadedTilesetsMap.value[key] = result
    }
  } catch (error) {
    console.error('加载3D模型失败:', error)
  }
}

// 从地图卸载模型
const removeTilesetFromMap = (key: string) => {
  const result = loadedTilesetsMap.value[key]
  if (result && typeof result.destroy === 'function') {
    result.destroy()
    delete loadedTilesetsMap.value[key]
  }
}

// 处理树节点选中（单击）
const onModelSelect = (selectedKeys: string[], e: any) => {
  const node = e.node
  if (node.isLeaf && node.selectable !== false) {
    const { dataRef, type } = node
    if (dataRef && type) {
      // 调用原有的模型加载逻辑（例如打开弹窗等）
      handleModelItemClick(dataRef, type)
    }
  }
}

// 处理树节点勾选（复选框）
const onModelCheck = (checkedKeys: string[], e: any) => {
  modelCheckedKeys.value = checkedKeys
  const node = e.node
  if (!node || !node.dataRef || !['pointCloud', 'b3dm'].includes(node.type)) return
  const { dataRef, type, key } = node
  if (e.checked) {
    loadTilesetToMap(dataRef, type, key)
  } else {
    removeTilesetFromMap(key)
  }
}

// 获取文件夹分类数据
const fetchModelList = async (folderId: number) => {
  try {
    if (folderCategoryData.value[folderId]) return
    const res = await getModelsByFolderIdClassification(folderId)
    folderCategoryData.value[folderId] = res.data || {}
  } catch (error) {
    console.error(`获取文件夹 ${folderId} 的分类数据失败:`, error)
    folderCategoryData.value[folderId] = {}
  }
}

// 获取所有模型文件夹树
const fetchModelFolders = async () => {
  try {
    const res = await getUserProjectFolders()
    folderList.value = res.data

    if (folderList.value.length > 0) {
      // 递归获取所有叶子文件夹
      const leafFolders: any[] = []
      const collectLeafFolders = (nodes: any[]) => {
        nodes.forEach(node => {
          if (node.children && node.children.length > 0) {
            collectLeafFolders(node.children)
          } else {
            leafFolders.push(node)
          }
        })
      }
      folderList.value.forEach(workspace => {
        if (workspace.children?.length) {
          collectLeafFolders(workspace.children)
        }
      })
      await Promise.all(leafFolders.map(leaf => fetchModelList(leaf.id)))
    }
  } catch (error) {
    console.error('获取模型文件夹失败:', error)
  }
}

// 计算总模型数量
const getTotalModelCount = () => {
  let count = 0
  const countNodes = (nodes: any[]) => {
    nodes.forEach(node => {
      if (node.isLeaf && node.selectable !== false && !node.disabled) count++
      if (node.children) countNodes(node.children)
    })
  }
  countNodes(modelTreeData.value)
  return count
}

// 计算模型树数据
const modelTreeData = computed(() => {
  return folderList.value.map(workspace => {
    const workspaceNode: any = {
      title: workspace.workspaceName,
      key: `workspace-${workspace.workspaceId}`,
      selectable: false,
      checkable: false,
      children: []
    }
    if (workspace.children && workspace.children.length > 0) {
      workspaceNode.children = buildFolderTree(workspace.children, `workspace-${workspace.workspaceId}`)
    }
    return workspaceNode
  })
})

const pointCloud = reactive({
  point: false,
  model: false
})
const videoSegmentVisible = ref(false)
const videoSegmentUrls = ref<string[]>([])
const isLoadingVideoSegments = ref(false)
const currentVideoIndex = ref(0)
const photoUrl = ref('')
const entityModelTitle = ref('3D实体模型')
const entityModelVisible = ref(false)
const modelRef = ref()
const photoModelVisible = ref(false)
const orthophotoData = ref<any>(null)
const tileUrls = ref('')
const orthophotoDataUrl = ref('')

const handleModelItemClick = async (model: any, type?: string) => {
  console.log('handleModelItemClick 调用', model, type)

  // 如果没有传入 type，尝试从 model 中推断
  if (!type) {
    if (model.modelUrl && model.model3dType !== 'ply') type = 'model3d'
    else if (model.modelUrl && model.model3dType === 'ply') type = 'ply'
    else if (model.modelUrl) {
      if (model.model3dType === 'cloud') type = 'pointCloud'
      else if (model.model3dType === 'b3dm') type = 'b3dm'
      else if (model.model3dType === 'orthophoto') type = 'orthophoto'
      else if (model.model3dType === 'timeLapse') type = 'videoSlice'
      else type = 'b3dm' // 默认当作地图模型
    } else if (model.orthophotoUrl) type = 'orthophoto'
    else if (model.videoUrl || model.videoSliceResult) type = 'videoSlice'
    else return
  }

  const loadPointCloudOrModel = (url: string, isPointCloud: boolean) => {
    pointCloud.model = store.state.showModelTileset
    pointCloud.point = store.state.showPointCloud
    store.commit('SET_POINT_CLOUD', false)
    pointCloudModelFn(false)
    nextTick(() => {
      clearPointCloudModel()
      load3DTiles(url, {
        skipTransform: true,
        position: { lng: state.position.longitude, lat: state.position.latitude },
        scale: 1.0,
        show: true,
        loadPointCloud: isPointCloud,
        loadModel: !isPointCloud,
        maximumScreenSpaceError: 1,
      })
    })
  }

  switch (type) {
    case 'model3d':
    case 'ply': {
      // 实体模型：使用 GlbModel 组件加载 modelUrl
      entityModelTitle.value = type === 'model3d' ? '3D实体模型' : '高斯模型'
      entityModelVisible.value = true
      nextTick(() => {
        if (modelRef.value?.loadSelectedModel) {
          modelRef.value.loadSelectedModel({
            modelName: model.modelName,
            modelUrl: model.modelUrl, // 使用 modelUrl
            fileType: model.model3dType || (type === 'ply' ? 'ply' : 'gltf'),
            thumbnailUrl: model.thumbnailUrl,
          })
        }
      })
      break
    }
    case 'b3dm':
    case 'pointCloud': {
      const key = type === 'pointCloud' ? `${model.id || model.folderId}-pointCloud` : `${model.id || model.folderId}-b3dm`
      if (!modelCheckedKeys.value.includes(key)) {
        modelCheckedKeys.value = [...modelCheckedKeys.value, key]
      }
      await loadTilesetToMap(model, type, key)
      break
    }

    case 'orthophoto': {
      if (model.tiles) {
        orthophotoDataUrl.value = model
        orthophotoData.value = model.tiles
        photoModelVisible.value = true
        await getTileUrls(
          model.tiles.orthophotoTileId,
          model.tiles.orthophotoPath,
          model.tiles.orthophotoTilesX,
          model.tiles.orthophotoTilesY
        ).then(response => {
          if (response.code === 0) tileUrls.value = response.data
        })
      } else if (model.modelUrl) {
        downloadOrthophoto(model.modelUrl)
      }
      break
    }
    case 'videoSlice': {
      videoSegmentVisible.value = true
      if (model.videoSliceResult) {
        const formData = new FormData()
        formData.append('path', model.videoSliceResult.path)
        formData.append('sliceId', model.videoSliceResult.sliceId)
        formData.append('sliceSize', model.videoSliceResult.sliceSize)
        try {
          const res = await getVideoSegmentUrl(formData)
          if (res.code === 0 && res.data) {
            videoSegmentUrls.value = res.data
            currentVideoIndex.value = 0
          }
        } catch (error) {
          console.error('获取视频切片失败', error)
          videoSegmentUrls.value = model.videoUrl ? [model.videoUrl] : []
        }
      } else if (model.videoUrl) {
        videoSegmentUrls.value = [model.videoUrl]
        currentVideoIndex.value = 0
      }
      break
    }
    default:
      console.warn('未知的模型类型:', type)
  }
}

const currentModelKey = ref<string | null>(null)

const entityModelCancel = () => {
  entityModelVisible.value = false
  modelRef.value.removeCurrentModel()
}

const photoModelCancel = () => {
  photoModelVisible.value = false
  photoUrl.value = ''
}

const videoPlayerRef = ref<HTMLVideoElement | null>(null)

const videoSegmentCancel = () => {
  videoSegmentVisible.value = false
  videoSegmentUrls.value = []
  currentVideoIndex.value = 0
  if (videoPlayerRef.value) {
    videoPlayerRef.value.pause()
    videoPlayerRef.value.src = ''
  }
}

const onVideoEnded = () => {
  if (currentVideoIndex.value < videoSegmentUrls.value.length - 1) {
    // 播放下一个片段
    currentVideoIndex.value++
    // 确保新片段自动播放
    nextTick(() => {
      videoPlayerRef.value?.play()
    })
  } else {
    // 所有片段播放完毕，可循环或关闭
    // 此处根据需求决定，例如循环从第一段开始：
    // currentVideoIndex.value = 0
    // videoPlayerRef.value?.play()
  }
}

const downloadOrthophoto = (url) => {
  window.open(url, '_blank')
}

const handleShowMask = async (val) => {
  if (xinLongMask.value) {
    viewer.value?.entities.remove(xinLongMask.value)
    xinLongMask.value = null
  }
  if (val) {
    const response = await fetch('/data/geoJson/440112.json', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    const geoJsonData = await response.json()
    console.log(geoJsonData, 'geoJsonData')

    const maskpointArray = []
    // 这里的数据筛选要大家根据自己的json数据结构进行获取
    const arr = geoJsonData.features[0].geometry.coordinates[0][0]
    // 处理莱西市的边界数据，整理成我们想要的格式
    for (let i = 0, l = arr.length; i < l; i++) {
      maskpointArray.push(arr[i][0])
      maskpointArray.push(arr[i][1])
    }

    // 将其转换成下边渲染entity所需的3D笛卡尔坐标系。
    const maskspoint = Cesium.Cartesian3.fromDegreesArray(maskpointArray)
    xinLongMask.value = new Cesium.Entity({
      id: 'xinlongMask',
      polygon: {
        hierarchy: {
        // 定义多边形或孔外边界的线性环。
          positions: Cesium.Cartesian3.fromDegreesArray([
            0, 0, 0, 90, 179, 90, 179, 0,
          ]),
          // 一组多边形层次结构，定义多边形中的孔。
          holes: [
            {
              positions: maskspoint, // 挖空区域
            },
          ],
        },
        // 填充多边形的材质
        material: Cesium.Color.WHITE.withAlpha(0.35),
      },
    })
    viewer.value?.entities.add(xinLongMask.value)
  }
}

onMounted(async () => {
  const app = getApp()
  await Promise.all([initCesiumMap(cesiumContainer.value, app)])
  viewer.value = getCesiumMap()
  store.commit('SET_EDIT_ROUTER', false)
  emitter.on('flightAreasDroneLocation', getDrawCallback)
  emitter.on('elementMarkInfo', getDrawMarkCallback)
  emitter.on('graphicUpdated', getDrawGraphicUpdatedCallback)
  mapDataSource.value = getCesiumDataSource()
  drawings.value = states.drawTool.getDrawings()
  await getGeoJson()
  mask.value = await BorderMaskManager.createBorderMask(
    '/data/geoJson/440112.json',
    {
      borderWidth: 3,
    }
  )
  setTimeout(async () => {
    handleShowMask(store.state.isShowMask)
    for (const key in xinglongMaskList) {
      const element = xinglongMaskList[key]
      if (!element.mask) {
        const geoJsonPromise = await BorderMaskManager.createBorderMask(
          element.path || element.data,
          element.options,
        )
        element.mask = geoJsonPromise
      }
    }
    if (store.state.markList && store.state.markList.length > 0) {
      await states.drawTool?.addAPIResponseGraphics(store.state.markList)
    }
    if (
      store.state.custumFlyList &&
    store.state.custumFlyList.length > 0 &&
    isFlyArea.value
    ) {
      await states.drawFlightArea?.setCircleList(store.state.custumFlyList)
    }
    emitter.emit('mapInited')
    isMapInited.value = true
  }, 5000)
  fetchModelFolders()
  loadModelList(true)
})

onBeforeUnmount(() => {
  if (mask.value) BorderMaskManager.removeBorderMask()
  if (xinLongMask.value) viewer.value?.entities.remove(xinLongMask.value)
  for (const key in xinglongMaskList) {
    const element = xinglongMaskList[key]
    if (element.mask) {
      BorderMaskManager.removeBorderMask()
      element.mask = null
    }
  }
  // 清理测距事件
  clearMeasure()
  emitter.off('flightAreasDroneLocation')
  emitter.off('elementMarkInfo')
  emitter.off('graphicUpdated')
  if (states.drawTool) {
    states.drawTool.destroy()
  }
  if (state.drawFlightArea) {
    state.drawFlightArea.clearEntity()
  }
  if (state.drawRouteTool) {
    state.drawRouteTool.destroy()
  }
  if (viewer.value) {
    // viewer.value.camera.moveEnd.removeEventListener(cameraMoveEvent)
    viewer.value.destroy()
    viewer.value = null
  }
  if (tempEntityId.value) {
    state.drawFlightArea?.removeEntity(tempEntityId.value)
  }
  if (currentBuildingTileset.value) {
    currentBuildingTileset.value.destroy()
  }
})
</script>

<style scoped lang="scss">
  $antPrefix: 'ant';

.route-core-info {
  padding: 24px;
  position: fixed;
  bottom: 52px;
  left: 656px;
  z-index: 1001;
  width: 1168px;
  height: 154px;
  background: var(--colorBgElevated);
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--colorText);
  transition: all 0.4s;

  &.is-template {
    left: 880px;
    width: 1025px;
  }

  &.is-device {
    left: 880px;
    width: 1080px;
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    .route-name {
      width: 300px;
      height: 28px;
      line-height: 28px;
      font-weight: 500;
      font-size: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .create-info {
      display: flex;
      align-items: center;
      font-size: 14px;

      .anticon {
        font-size: 17px;
      }

      .creator {
        margin: 0 8px;
      }

      .phone {
        margin-right: 17px;
      }

      .create-time {
        margin-left: 8px;
        margin-right: 17px;
      }
    }
  }

  .bottom {
    display: flex;
    align-items: center;
    -webkit-user-select: none;
    user-select: none;

    .area-item {
      width: 150px !important;
    }

    .wayline-info-item {
      margin-right: 24px;
      width: 120px;

      .title {
        margin-bottom: 8px;
        width: 100%;
        height: 22px;
        line-height: 22px;
        font-weight: 400;
        font-size: 14px;
        color: var(--colorTextSecondary);
      }

      .text {
        max-width: 120px;
        height: 24px;
        line-height: 24px;
        font-weight: 500;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .update-time {
        position: relative;
        bottom: 1px;
        left: 8px;
        font-weight: 400;
        font-size: 14px;
      }
    }
  }

  .wayline-propety,
  .end-update-time {
    width: 200px !important;
  }
}

.uva-level {
  width: 152px;
  height: 116px;

  .v-l-tip {
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    font-size: 16px;

    .tip-txt {
      font-weight: bold;

      i {
        cursor: pointer;
      }
    }
  }

  .v-l-check {
    margin: 6px 0 0;

    .check-content {
      display: flex;
      align-items: center;
      margin-left: 4px;

      .svg-icon {
        border-radius: 50%;
        border: 1px solid;

        &.color-error {
          border-color: #dc4446;
        }

        &.color-warning {
          border-color: #d89614;
        }

        &.color-primary {
          border-color: #297acf;
        }
      }

      .check-txt {
        line-height: 20px;
        margin: 0 0 0 4px;
        color: #fff;
      }
    }
  }
}

.flight-area {
  width: 180px;
  height: 325px;

  .ant-divider {
    background-color: rgba(253, 253, 253, 0.12);
  }

  .f-a-switch {
    display: flex;
    font-size: 16px;

    .txt {
      line-height: 22px;
      margin: 0 0 0 4px;
    }
  }

  .f-a-txt {
    margin: 0 0 6px;
    text-align: center;
    display: flex;
    align-items: center;
    padding: 0 0 0 34px;

    .color1 {
      border-color: red;
      border-style: dotted;
      background-color: #ff000080;
    }

    .color2 {
      border-color: #0f0;
      border-style: dotted;
    }

    .txt {
      line-height: 20px;
      margin: 0 0 0 4px;
    }
  }

  .f-a-tips {
    margin: 0 0 0 20px;
  }

  .f-a-check {
    margin: 0 0 0 10px;

    .check-content {
      display: flex;

      .color3 {
        border-color: #e2573f;
        background-color: #e2573f80;
      }

      .color4 {
        border-color: #989898;
        background-color: #98989880;
      }

      .color5 {
        border-color: #1389f2;
        background-color: #1389f280;
      }

      .color6 {
        border-color: #ffcc03;
        background-color: #ffcc0380;
      }

      .color7 {
        border-color: #ee8918;
        background-color: #ee891880;
      }

      .color8 {
        border-color: #39c4db;
        background-color: #39c4db80;
      }

      .color9 {
        border-color: #1dc61d;
        background-color: #1dc61d80;
      }

      .check-txt {
        line-height: 20px;
        margin: 0 0 0 4px;
        color: #fff;
      }
    }
  }

  .round {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 3px dotted red;
    border-radius: 50%;
    line-height: 24px;
  }
}

.cesium-container {
  height: 100%;
  width: 100%;
  position: absolute;
  overflow: hidden;

  &.data-ui {
    :deep(.compass) {
      right: 25%;
    }
  }

  .notie-list {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 99%;
    z-index: 301;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    padding: 12px;
    background: #fff4e6;
    border-radius: 4px;

    &.is-template {
      left: 445px;
      width: 74%;
    }

    &.is-device {
      left: 275px;
      width: 83.5%;
    }

    &.is-waline-edit {
      top: 63px;
    }

    &.active {
      top: 3px;
      left: 5px;
    }

    .notie-title-type {
      -webkit-box-flex: 0;
      flex: none;
      line-height: 16px;
      padding: 0 8px;
      font-size: 12px;
      border: 1px solid #be4e04;
      color: #be4e04;
      border-radius: 4px;
    }

    .notie-title-value {
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      margin-left: 8px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .detail-btn {
      -webkit-box-flex: 0;
      -ms-flex: none;
      flex: none;
      cursor: pointer;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      color: #0070d5;
      font-size: 14px;

      .arrow-right {
        width: 6px;
        height: 6px;
        margin-left: 4px;
        background-color: transparent;
        border-color: #0070d5;
        border-style: solid;
        border-width: 1px 1px 0 0;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }
  }

  .cesium-map {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 300;
  }

  :deep(.current) {
    .cesium-widget {
      canvas {
        cursor:
          url("/src/assets/icons/startPoint.png") 20 20,
          pointer;
      }
    }
  }

  :deep(.addCurrent) {
    .cesium-widget {
      canvas {
        cursor:
          url("/src/assets/icons/route-edit-add.svg") 20 20,
          pointer;
      }
    }
  }

  // 操作按钮面板
  .cesium-action-pane {
    position: absolute;
    top: 50px;
    right: 16px;
    z-index: 400;

    &.edit {
      top: 76px;
    }

    .g-action-item {
      width: 28px;
      height: 28px;
      background-color: black;
      color: $primary;
      border-radius: 2px;
      line-height: 28px;
      text-align: center;
      margin-bottom: 2px;
      border: 2px solid;
      border-color: black;
      border-radius: 2px 2px 0 0;
      position: relative;
      cursor: pointer;

      &:hover {
        border-color: $primary;
      }
      &.disabled {
        &:hover {
          border-color: black;
        }
      }
    }

    .selection {
      border-color: $primary;

      &:before {
        content: "";
        position: absolute;
        right: -2px;
        top: -2px;
        border-width: 7px;
        border-style: solid;
        border-color: #00afff #00afff transparent transparent;
      }
    }
  }
}

.map-sidebar-com {
  .model-list-btn {
    // position: absolute;
    // right: 15px;
    // top: 250px;
    z-index: 1000;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    background: #1f1f1f; // 改为与右侧图标相同的深灰色
    backdrop-filter: blur(12px) saturate(180%);
    padding: 5px;
    border-radius: 3px;
    border: 1px solid rgba(255, 255, 255, 0.1); // 边框微调为半透明白色，更自然
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
    transition: all 0.3s ease;
    color: rgba(255, 255, 255, 0.8);

    &:hover {
      background: rgba(31, 31, 31, 0.05); // 悬停时略微提亮背景
      color: #1890ff; // 文字变为主蓝色
      border-color: #1890ff; // 边框也变为主蓝色
    }

    .anticon {
      font-size: 14px;
    }

    .btn-text {
      font-size: 14px;
      font-weight: 500;
      white-space: nowrap;
    }

    // 树形结构悬停列表样式
    .tree-model-list-popover {
      position: absolute;
      top: 0;
      right: 30px;
      width: 350px;
      max-height: 500px;
      background: #1f1f1f; // 深灰色背景
      backdrop-filter: blur(12px) saturate(180%);
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
      overflow: hidden;
      z-index: 1001;

      .tree-list-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        background: rgba(0, 0, 0, 0.3); // 更深的头部背景
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        .tree-list-title {
          color: rgba(255, 255, 255, 0.9);
          font-size: 14px;
          font-weight: 600;
        }

        .model-count {
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
          background: rgba(255, 255, 255, 0.1);
          padding: 2px 8px;
          border-radius: 10px;
        }
      }

      .tree-list-content {
        max-height: 450px;
        overflow-y: auto;
        padding: 8px;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
          background: rgba(24, 144, 255, 0.5); // 主蓝色滚动条
          border-radius: 3px;

          &:hover {
            background: rgba(24, 144, 255, 0.7);
          }
        }

        .tree-workspace,
        .tree-folder,
        .tree-subfolder,
        .tree-model {
          margin-bottom: 4px;

          .tree-workspace-header,
          .tree-folder-header,
          .tree-subfolder-header,
          .tree-model-header {
            cursor: pointer;
            padding: 8px 12px;
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 6px;
            transition: all 0.2s ease;

            &:hover {
              background: rgba(24, 144, 255, 0.1);
              border-color: rgba(24, 144, 255, 0.3);
            }

            .tree-node-title {
              display: flex;
              align-items: center;
              gap: 8px;
              color: rgba(255, 255, 255, 0.8);
              font-size: 13px;

              .tree-caret-icon {
                font-size: 12px;
                color: rgba(24, 144, 255, 0.8);
                flex-shrink: 0;
              }

              .tree-node-name {
                flex: 1;
                font-weight: 600;
              }

              .tree-node-count {
                color: rgba(255, 255, 255, 0.5);
                font-size: 12px;
                background: rgba(255, 255, 255, 0.1);
                padding: 2px 8px;
                border-radius: 10px;
              }
            }
          }

          .tree-children,
          .tree-subfolders,
          .tree-models {
            margin-top: 6px;
            padding-left: 20px;
          }

          .tree-model-types {
            margin-top: 4px;
            padding-left: 20px;

            .tree-model-type {
              cursor: pointer;
              margin-bottom: 4px;
              padding: 8px 12px;
              background: rgba(255, 255, 255, 0.05);
              border: 1px solid rgba(255, 255, 255, 0.1);
              border-radius: 6px;
              transition: all 0.2s ease;

              &:hover {
                background: rgba(24, 144, 255, 0.1);
                border-color: rgba(24, 144, 255, 0.3);
                transform: translateX(2px);
              }

              &.active {
                background: rgba(24, 144, 255, 0.15);
                border-color: rgba(24, 144, 255, 0.5);
                box-shadow: 0 0 12px rgba(24, 144, 255, 0.3);

                .model-type-check {
                  color: #1890ff;
                }
              }

              .model-type-content {
                display: flex;
                align-items: center;
                gap: 10px;

                .model-type-icon {
                  flex-shrink: 0;
                  width: 24px;
                  height: 24px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background: rgba(24, 144, 255, 0.15);
                  border-radius: 4px;
                  color: rgba(24, 144, 255, 0.9);
                  font-size: 12px;
                }

                .model-type-info {
                  flex: 1;
                  min-width: 0;

                  .model-type-name {
                    display: block;
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 13px;
                    font-weight: 500;
                    margin-bottom: 2px;
                  }

                  .model-type-desc {
                    display: block;
                    color: rgba(255, 255, 255, 0.5);
                    font-size: 11px;
                    background: rgba(255, 255, 255, 0.05);
                    padding: 1px 6px;
                    border-radius: 3px;
                    display: inline-block;
                  }
                }

                .model-type-check {
                  flex-shrink: 0;
                  font-size: 12px;
                  color: rgba(255, 255, 255, 0.3);
                }
              }
            }
          }
        }
      }
    }
  }
  .ply-icon {
    position: absolute;
    right: 15px;
    top: 27%;
    z-index: 400;
    width: 28px;
    height: 28px;
    margin: 10px auto;
    border-radius: 2px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    background-color: #1f1f1f;
    color: rgba(255, 255, 255, 0.85);
    &:hover {
      color: #1088f2;
    }
  }
  .m-s-right-btn {
    position: absolute;
    right: 20px;
    bottom: 50px;
    z-index: 400;

    &.data-ui {
      right: 25.5%;
    }

    .td {
      font-weight: 700;
      color: #fff;
    }

    .m-s-icon {
      width: 28px;
      height: 28px;
      margin: 10px auto;
      border-radius: 2px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      position: relative;
      background-color: #1f1f1f;
      color: rgba(255, 255, 255, 0.85);

      &:hover {
        color: #1088f2;
      }
    }

    .m-s-zoom {
      width: 28px;
      margin: 10px auto;
      text-align: center;
      line-height: 28px;
      box-shadow: 0 0 4px #0009;
      cursor: pointer;

      .zoom-add {
        width: 28px;
        height: 28px;
        border-radius: 2px 2px 0 0;
        background-color: #1f1f1f;
        color: rgba(255, 255, 255, 0.85);

        &:hover {
          color: #1088f2;
        }
      }

      .zoom-minus {
        width: 28px;
        height: 28px;
        border-radius: 0 0 2px 2px;
        background-color: #1f1f1f;
        color: rgba(255, 255, 255, 0.85);

        &:hover {
          color: #1088f2;
        }
      }
    }

    .m-s-map-icon {
      width: 40px;
      height: 40px;
      background: #fff;
      border-radius: 50%;
      margin: 10px auto;
      padding: 3px 0 0;
      cursor: pointer;

      .select-btn {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        margin: 0 auto;
        -webkit-user-select: none;
        user-select: none;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
    }
  }
}

.add-waypoint-tips {
  .a-d-t {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--colorTextBase);
    font-weight: 400;
    font-size: 16px;
  }
  .a-d-t-title {
    margin-bottom: 5px;
    .a-d-t-title-text {
      margin-left: 8px;
    }
  }

  .a-d-t-content {
    .a-d-t-c-key {
      width: 40px;
      padding: 0 5px;
      border: 1px solid var(--colorTextBase);
      line-height: 17px;
      text-align: center;
    }

    .a-d-t-c-add {
      margin: 0 10px;
    }

    .a-d-t-c-text {
      margin-left: 10px;
    }
  }
}

.map-imglayer-data {
  width: 360px;
  height: 100px;
  position: relative;

  .m-i-d-title {
    font-weight: 600;
    margin: 0 0 6px;
    font-size: 14px;
  }

  .m-i-d-switch {
    display: flex;
    font-size: 14px;
    margin: 0 0 6px;

    .txt {
      line-height: 22px;
      margin: 0 0 0 4px;
    }
  }

  .switch-right {
    margin-left: 50px;
  }

  .select-imglayer {
    width: 100%;
    height: 100px;
    display: flex;
    // justify-content: space-around;

    .vec-w,
    .img-w {
      width: 120px;
      height: 80px;
      background-size: 100% 100%;
      position: relative;
      border: 2px solid #fff;

      &.active,
      &:hover {
        border: 2px solid #2d8cf0;

        .vec-w-name span,
        .img-w-name span {
          background-color: #2d8cf0;
        }
      }
    }

    .vec-w {
      background-image: url("/@/assets/images/map-icon2.png");
    }

    .img-w {
      background-image: url("/@/assets/images/map-icon.png");

      .img-w-mark {
        height: 24px;
        padding: 0 4px;
        background: #00000080;
        display: flex;
        color: #fff;

        .ant-checkbox-group {
          width: 30px;
        }

        .ant-checkbox-wrapper {
          color: #fff;
        }

        .txt {
          line-height: 22px;
          margin: 0 0 0 4px;
        }
      }
    }

    .vec-w-name,
    .img-w-name {
      position: absolute;
      right: 0;
      bottom: 0;
      line-height: 22px;
      color: #fff;
      width: 100%;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.5),
        transparent 0,
        rgba(0, 0, 0, 0.4)
      );
      text-align: right;

      span {
        padding: 0 4px;
      }
    }
  }
}

.building-control-panel {
  position: absolute;
  top: 100px;
  right: 50px;
  width: 320px;
  background: rgba(255, 255, 255, 0.98);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 80vh;
  overflow-y: auto;

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #e8e8e8;
    background: #fafafa;
    border-radius: 8px 8px 0 0;

    h4 {
      margin: 0;
      font-size: 16px;
      color: #1890ff;
    }

    .anticon-close {
      cursor: pointer;
      color: #999;
      font-size: 14px;

      &:hover {
        color: #ff4d4f;
      }
    }
  }

  .panel-content {
    padding: 16px;

    .error-message {
      margin-bottom: 12px;
    }

    .data-source-info {
      margin-bottom: 12px;
    }

    .custom-input {
      margin-bottom: 16px;
    }

    .building-controls {
      display: flex;
      margin: 16px 0;
      padding: 12px 0;
      border-top: 1px solid #f0f0f0;
      border-bottom: 1px solid #f0f0f0;
    }

    .performance-stats {
      margin: 12px 0;

      .stat-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        font-size: 12px;
        color: #666;

        span:first-child {
          color: #333;
          font-weight: 500;
        }
      }
    }

    .usage-tips {
      margin-top: 12px;
      font-size: 12px;
      color: #888;
    }
  }
}
.share-point-panel {
  position: absolute;
  left: 500px;
  top: 300px;
  padding: 8px;
  background-color: #1f1f1f;
  z-index: 999;
  border-radius: 4px;
  .share-btn {
    padding: 0 10px 10px;
    position: relative;
    line-height: 30px;
    color: #fff;
  }
  .share-image-box {
    padding: 5px;
  }
}

/* 测距浮动面板样式 */
.measure-info-panel {
  position: absolute;
  bottom: 100px;
  left: 20px;
  min-width: 180px;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  border-radius: 8px;
  padding: 12px 16px;
  color: white;
  z-index: 1000;
  font-size: 14px;
  border-left: 3px solid #1890ff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  pointer-events: auto;

  .measure-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-weight: 600;
    color: #1890ff;

    .anticon-close {
      cursor: pointer;
      font-size: 12px;
      &:hover {
        color: #ff4d4f;
      }
    }
  }

  .measure-content {
    .total-distance {
      font-size: 16px;
      strong {
        font-size: 18px;
        color: #52c41a;
      }
    }
    .measure-tip {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.6);
      margin-top: 6px;
    }
  }
}
.measure-info-panel {
  .current-segment {
    font-size: 12px;
    color: #ffaa00;
    margin-top: 4px;
  }
}

:deep(.model-a-tree) {
  &.#{$antPrefix}-tree {
    background-color: #1F1F1F !important;
    color: #fff !important;
    min-height: 100%;

    &,
    & > ul,
    & ul,
    & li,
    & li > ul {
      background-color: #1F1F1F !important;
      color: #fff !important;
    }

    > li {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }

    .#{$antPrefix}-tree-treenode {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding-top: 0;
      padding-bottom: 0;
      background-color: #1F1F1F !important;
      color: #fff !important;

      &:first-child {
        padding-top: 4px !important;
      }

      &-disabled {
        > .#{$antPrefix}-tree-node-content-wrapper {
          height: 20px !important;
          span {
            color: #fff !important;
          }
        }
      }

      > ul {
        width: 100% !important;
        background-color: #1F1F1F !important;
      }
    }

    .#{$antPrefix}-tree-switcher {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff !important;
      background-color: transparent !important;

      &-icon {
        color: #fff !important;
        fill: #fff !important;
        svg {
          color: #fff !important;
          fill: #fff !important;
        }
      }

      &:hover {
        color: #fff !important;
        background-color: transparent !important;
      }
    }

    .#{$antPrefix}-tree-checkbox {
      z-index: 1;
      margin: 0 4px 0 0 !important;

      &:hover::after,
      .#{$antPrefix}-tree-checkbox-wrapper:hover &::after {
        visibility: collapse !important;
      }

      .#{$antPrefix}-tree-checkbox-inner {
        border-color: #fff !important;
        background-color: transparent !important;

        &::after {
          border-color: #fff !important;
        }
      }

      &-checked,
      &-indeterminate {
        .#{$antPrefix}-tree-checkbox-inner {
          background-color: #1F1F1F !important;
          border-color: #fff !important;

          &::after {
            border-color: #fff !important;
          }
        }
      }
    }

    .#{$antPrefix}-tree-node-content-wrapper {
      color: #fff !important;
      background-color: transparent !important;
      width: calc(100% - 46px) !important;
      flex: 1 !important;
      box-sizing: content-box !important;
      height: 20px !important;
      min-width: 0 !important;
      padding-right: 0 !important;
      margin-left: 0 !important;
      line-height: 20px !important;
      border-radius: 2px !important;

      &:hover,
      &:active,
      &:focus {
        background-color: #1F1F1F !important;
        color: #fff !important;
      }

      &:hover:not(.#{$antPrefix}-tree-node-selected) {
        background-color: #1F1F1F !important;
        color: #fff !important;
      }

      &:active,
      &.#{$antPrefix}-tree-node-selected {
        background-color: #1F1F1F !important;
        color: #fff !important;
      }

      .#{$antPrefix}-tree-title {
        color: #fff !important;
        display: block !important;
        line-height: 20px !important;
        width: 100% !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
      }
    }

    .#{$antPrefix}-tree-treenode-selected {
      > .#{$antPrefix}-tree-switcher {
        color: #fff !important;
      }

      > .#{$antPrefix}-tree-checkbox {
        .#{$antPrefix}-tree-checkbox-inner {
          border-color: #fff !important;
        }
      }

      > .#{$antPrefix}-tree-node-content-wrapper {
        background-color: #1F1F1F !important;
        color: #fff !important;

        .#{$antPrefix}-tree-title {
          color: #fff !important;
        }
      }
    }

    &-draggable {
      .#{$antPrefix}-tree-node-content-wrapper[draggable='true'] {
        &:hover {
          background-color: #1F1F1F !important;
          color: #fff !important;
        }

        &:active {
          background-color: #1F1F1F !important;
          color: #fff !important;
        }
      }
    }
  }

  .#{$antPrefix}-tree li .#{$antPrefix}-tree-node-content-wrapper {
    &:hover {
      background-color: #1F1F1F !important;
      color: #fff !important;
    }

    &.#{$antPrefix}-tree-node-selected {
      background-color: #1F1F1F !important;
      color: #fff !important;
    }
  }

  .#{$antPrefix}-tree-node-content-wrapper {
    position: relative;

    &:hover {
      .#{$antPrefix}-tree-title {
        &[title] {
          &::after {
            content: attr(data-title);
            position: absolute;
            left: 50%;
            bottom: 100%;
            transform: translateX(-50%);
            background-color: rgba(0, 0, 0, 0.75);
            color: white;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 12px;
            white-space: nowrap;
            z-index: 9999;
            pointer-events: none;
            opacity: 0;
            transition: opacity 0.3s;
            margin-bottom: 5px;
          }

          &:hover::after {
            opacity: 1;
          }
        }
      }
    }
  }
}

.orth-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.orthDownload {
  margin-right: 3vw;
  font-size: 20px;
  cursor: pointer;
  color: #1890ff;
}
// 定位弹窗内容面板样式
.location-panel {
  min-width: 260px;
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;

  // 每个输入项：标签 + 输入框
  .location-field {
    display: flex;
    align-items: center;
    gap: 12px;

    .field-label {
      width: 36px;
      font-size: 13px;
      font-weight: 500;
      color: #fff;
      letter-spacing: 0.3px;
    }

    // 覆盖 Ant Design 输入框样式
    .ant-input-number {
      flex: 1;
      width: auto;
      border-radius: 6px;
      border-color: #dcdfe6;
      transition: all 0.2s;

      &:hover {
        border-color: #c0c4cc;
      }

      &:focus,
      &-focused {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }

      .ant-input-number-input {
        font-size: 12px;
        padding: 4px 8px;
      }
    }
  }

  // 定位按钮
  .ant-btn-primary {
    margin-top: 4px;
    border-radius: 6px;
    font-weight: 500;
    height: 30px;
    font-size: 12px;
    background-color: #409eff;
    border-color: #409eff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    transition: all 0.2s;

    &:hover {
      background-color: #66b1ff;
      border-color: #66b1ff;
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(64, 158, 255, 0.2);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

// 弹窗标题样式（若有需要）
.title-loction {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}
</style>
